/* eslint-disable indent */
import { Overlay } from '@angular/cdk/overlay';
import { PlatformLocation } from '@angular/common';
import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { ActivatedRoute, Data, Router } from '@angular/router';
import { MASKS } from 'ng-brazil';
import swal from 'sweetalert2';
import { opcoesOrientacao, opcoesTelhado } from '../globals';
import { AnexoModalComponent } from '../modals/anexo-modal/anexo-modal.component';
import { ClientesModalComponent } from '../modals/clientes-modal/clientes-modal.component';
import { ComissoesModalComponent } from '../modals/comissoes-modal/comissoes-modal.component';
import { DetalheEstruturaModalComponent } from '../modals/detalhe-estrutura-modal/detalhe-estrutura-modal.component';
import { DetalheProdutoModalComponent } from '../modals/detalhe-produto-modal/detalhe-produto-modal.component';
import { DigitaCampoModalComponent } from '../modals/digita-campo-modal/digita-campo-modal.component';
import { IrradiacaoModalComponent } from '../modals/irradiacao-modal/irradiacao-modal.component';
import { KitsSugeridosModalComponent } from '../modals/kits-sugeridos-modal/kits-sugeridos-modal.component';
import { LayoutModalComponent } from '../modals/layout-modal/layout-modal.component';
import { ProdutosModalComponent } from '../modals/produtos-modal/produtos-modal.component';
import { Cliente } from '../models/cliente';
import { Comissao } from '../models/comissao';
import { StatusDoPedido, TipoFiltroProduto } from "../models/enum";
import { Fileira } from '../models/fileira';
import { Ibge } from '../models/ibge';
import { ItemDesc, ItemPedido, Pedido } from '../models/pedido';
import { Produto, ProdutoDesconto } from '../models/produto';
import { VendaEntrega } from '../models/venda-entrega';
import { ViaCep } from '../models/viacep';
import { CadastrarEstruturaComponent } from '../pedido/cadastrar-estrutura/cadastrar-estrutura.component';
import { CarregandoService } from '../services/carregando.service';
import { ClienteService } from '../services/cliente.service';
import { ComissaoService } from '../services/comissao.service';
import { CondicaoDePagamentoService } from '../services/condicao-de-pagamento.service';
import { EnderecoService } from '../services/endereco.service';
import { FormaDePagamentoService } from '../services/forma-de-pagamento.service';
import { FuncionarioService } from '../services/funcionario.service';
import { GlobalService } from '../services/global.service';
import { IbgeService } from '../services/ibge.service';
import { IrradiacaoService } from '../services/irradiacao.service';
import { LogAcessoService } from '../services/log-acesso.service';
import { NotificacaoService } from '../services/notificacao.service';
import { PedidoService } from '../services/pedido.service';
import { PremissasService } from '../services/premissas.service';
import { ProdutoService } from '../services/produto.service';
import { RelatorioService } from '../services/relatorio.service';
import { UtilitarioService } from '../services/utilitario.service';
import { ViaCepService } from '../services/via-cep.service';
import { FornecedorEstruturaService } from '../services/fornecedor-estrutura.service';
import { VendaResposta } from '../models/venda-resposta';
import { DescontoIndividualModalComponent } from '../modals/desconto-individual-modal/desconto-individual-modal.component';
import { tryCatch } from 'rxjs/internal-compatibility';
import { UsuarioLogado } from '../models/usuario-logado';
import { delay } from 'rxjs/operators';
import { EstruturasPersonalizadas } from '../models/estruturas-personalizadas';
import { EstoqueProdutoModalComponent } from '../modals/estoque-produto-modal/estoque-produto-modal.component';
import { PrecificacaoUF } from '../models/precificacao-uf';
import { PremissasSistema } from '../models/premissas-sistema';
import { PrecificacaoUFService } from '../services/precificacao-uf.service';
import { ProdutosV2ModalComponent } from "../modals/produtos-v2-modal/produtos-v2-modal.component";
import { PremissasUsuario } from '../models/premissas-usuario';

// jquery
declare const $: any;

@Component({
  selector: 'app-kit-personalizado',
  templateUrl: './kit-personalizado.component.html',
  styleUrls: ['./kit-personalizado.component.scss']
})
export class KitPersonalizadoComponent implements OnInit, AfterViewInit, OnDestroy {

  limDesc = undefined;
  vendedor = undefined;
  // variáveis
  idOrcamento: string;
  cliente: Cliente;
  vendedorSelecionado = undefined;
  orcamento: Pedido = new Pedido();
  // paineis: Painel[] = [];
  fileiras: Fileira[] = [];
  novaFileira: Fileira = new Fileira();
  // novoPainel: Painel = new Painel();
  orientacoes = ['Paisagem', 'Retrato'];
  tabIndex = 0;
  itens: ItemPedido[] = [];
  confirmarSemValidar = false;
  descontoMaximo = 0;
  limiteDescontoUsuario = 0;
  limiteDescontoUsuarioLogado = 0;
  comissao: Comissao;

  valorFinal = 0;
  valorFinalSemDescontoIndividual = 0;

  intPodeAlterarCD = false;
  mostrarMsgTrocaCD = { valor: false, msg: '' };

  vendaProgramada = false;

  pUsarAcrescimo = false;

  usarCombImp = false;

  comprovante;

  confirmar = false;

  mostrarBifasico = false;

  msgQtdPaineis = false;

  itemSemLote = false;

  marcaStringbox;

  tabAlvo = 0;
  duplicando = false;
  // txFrete = 0;
  validaDesconto = false;
  StatusDoPedido = StatusDoPedido;
  qtdPainelSugestao = 0;
  clienteFaturamento = new Cliente();
  tabItensIndex = 1;

  estruturasPersonalizadas: EstruturasPersonalizadas = new EstruturasPersonalizadas();

  calcValorFinalSugestao = false;

  valorFinalComissao = 0;

  transportadoras: Cliente[] = [];

  produtoEstruturaBloqueado = false;

  calculadora;
  quantidadeDePaineis = 0;
  potenciaPainel = 0;
  potTotal = 0;
  potenciaDesejada = 0;
  fatorGeracao = 0;
  painel: any;
  tensao: 0;
  fase: 0;
  mostrarValores = false;
  public MASKS = MASKS;

  latitude;
  longitude;

  removerItemSugEdicao = false;

  tiposDePessoa = [{ id: 1, nome: 'FÍSICA' }, { id: 0, nome: 'JURÍDICA' }];

  integrador = false;

  customPatterns = {
    V: { pattern: new RegExp('(,|[0-9]|-|\\.)') },
    0: { pattern: new RegExp('[0-9]') }
  };

  potSistema;

  nomeVendedor = '';

  calculadoraMargem = { visivel: false, custoProdutos: 0, margem: 0, valorMinimo: 0, descontoMaximo: 0, descontoMaximoPerc: 0 };

  verCustos = undefined;

  texto = '';

  titulo = '';

  configurouLayout = false;

  idMarca: number;
  telhado: any;
  fornecedoresDisponiveis: any;
  fornecedorPadrao: any;
  fornecedorSelecionado: any;
  larguraPainel;
  comprimentoPainel;
  alturaPainel;

  validarKitCustomizado = false;
  objetoPainel: any;
  enderecoDeEntrega: VendaEntrega = new VendaEntrega();
  estadoSelecionado = undefined;
  cidadeSelecionado = undefined;
  nomeCidade = '';
  pesoBruto = 0;
  mostrarCodErp: false;
  multiFornecedores = false;

  usarCombInvStrCon = false;
  semState = false;

  usarTransformador = false;
  incluirStringBox = true;

  irradiacao;
  calculoGeracao = { numeroDiasMes: 30.4, eficienciaDoPainel: 0.86 };
  percGeracao = 100;

  meses = [];

  perdas = 0;
  producaoPorPainel;
  podeRecalcularEstrutura = false;
  novaQuantidadePaineis;

  nome;

  comEstrutura = false;

  regraValidacaoKitPersonalizado = 0;

  descontoFrete;
  clienteIntegrador;

  pCentroDistribuicao = false;
  telhadoNaCalculadora = false;
  pOcultarColunaDescricaoFileiras = false;

  tipoInv = -1;

  usuarioLogado: UsuarioLogado;

  respostas: VendaResposta[] = [];

  permissoesPedidoFuncionario = { podeEditarFrete: false, podeEditarServicoEntrega: false, podeEditarSeguro: false, podeDescontoIndividual: false, podeVerTotaisMonitores: false };

  podeVerEstoque = false;
  bloquearSistema: boolean = false;
  administrador: boolean = false;

  ibgeInstalacao: string;
  ufInstalacao: string;

  exibirLembreteVertys: boolean = false;


  precificacoesUF: PrecificacaoUF[] = [];

  premissasSistema: PremissasSistema;
  premissasUsuario = new PremissasUsuario();

  descAcresPrecificacaoUF: PrecificacaoUF;

  textoMonteSeuKit = 'Monte Seu Kit';

  area: number = 0;

  constructor(public dialog: MatDialog, private funcionarioService: FuncionarioService, private comissaoService: ComissaoService,
    private globalService: GlobalService, private viaCepService: ViaCepService, private ibgeService: IbgeService,
    private route: ActivatedRoute, private router: Router, private pedidoService: PedidoService,
    private clienteService: ClienteService, private notificacaoService: NotificacaoService,
    private carregandoService: CarregandoService, private formadePagamentoService: FormaDePagamentoService,
    public utilitarioService: UtilitarioService, private condicaoDePagamentoService: CondicaoDePagamentoService, private enderecoService: EnderecoService,
    private produtoService: ProdutoService, private overlay: Overlay, private relatorioService: RelatorioService,
    private logAcessoService: LogAcessoService, private platformLocation: PlatformLocation, private premissasService: PremissasService,
    private irradiacaoService: IrradiacaoService, private fornecedorEstruturaService: FornecedorEstruturaService,
    private precificacaoUFService: PrecificacaoUFService) {
    if (this.router.getCurrentNavigation().extras.state) {

      const state = JSON.parse(this.router.getCurrentNavigation().extras.state.stateJson);

      this.calculadora = state.calculadora;

      if (this.calculadora) {
        this.quantidadeDePaineis = state.quantidadeDePaineis;
        this.potenciaPainel = state.potenciaPainel;
        this.potTotal = state.potTotal;
        this.potenciaDesejada = state.potenciaDesejada;
        this.fatorGeracao = state.fatorGeracao;

        this.idMarca = state.marca;
        this.telhado = state.telhado;
        this.fornecedorPadrao = state.fornecedorPadrao;
        this.larguraPainel = state.larguraPainel;
        this.comprimentoPainel = state.comprimentoPainel;
        this.alturaPainel = state.alturaPainel;


        this.fornecedorSelecionado = state.fornecedorSelecionado;
        this.estadoSelecionado = state.uf;
        this.cidadeSelecionado = state.cidade;
        this.nomeCidade = state.nomeCidade;
        this.painel = state.painel;
        this.tensao = state.tensao;
        this.fase = state.fase;
        this.orcamento.painelProduto = state.objetoPainel;
        this.configurouLayout = true;
        this.usarTransformador = state.usarTransformador;

        if (state.incluirStringBox !== null && state.incluirStringBox !== undefined) {
          this.incluirStringBox = state.incluirStringBox;
        }

        this.marcaStringbox = state.marcaStringbox;

        this.meses = state.meses;

        this.fileiras = state.fileiras;

        if (this.fileiras !== null && this.fileiras !== undefined) {
          this.fileiras.forEach(p => p.buscouImagem = false);
        }

        this.cliente = state.cliente;
        this.nome = state.nome;
        this.comEstrutura = state.comEstrutura;

        this.tipoInv = state.tipoInv;

        this.vendedor = state.vendedor;
        this.limDesc = state.limDesc;

        this.ufInstalacao = state.uf;
        this.ibgeInstalacao = state.cidade;

      } else {
        this.orcamento.painel = state.painel;
        this.orcamento.tensao = state.tensao;
        this.orcamento.fase = state.fase;
        this.orcamento.painelProduto = state.objetoPainel;
        this.configurouLayout = true;
      }

    } else {
      this.semState = true;
      this.router.navigate(['/montar-kit']);
    }
  }

  buscarPremissasBloqueioSistema() {
    this.carregandoService.mostra('buscarBloqSist');
    this.premissasService.consultarBloqSistManuProd().subscribe(data => {
      this.bloquearSistema = data;
      this.carregandoService.esconde('buscarBloqSist');
    }, (erro) => {
      this.carregandoService.esconde('buscarBloqSist');
      this.notificacaoService.erro(erro);
    });
  }

  buscarExibirLembreteMontarKitVertys() {
    this.carregandoService.mostra('buscarExibirLembreteMontarKitVertys');
    this.premissasService.consultarExibirLembreteMontarKitVertys().subscribe(f => {
      this.exibirLembreteVertys = f.valor;
      this.carregandoService.esconde('buscarExibirLembreteMontarKitVertys');
    }, (erro) => {
      this.carregandoService.esconde('buscarExibirLembreteMontarKitVertys');
      this.notificacaoService.erro(erro);
    });
  }

  buscarNomeMenu() {
    this.carregandoService.mostra('textoMonteSeuKit');
    this.premissasService.textoMonteSeuKit().subscribe(
      (vars) => {
        this.textoMonteSeuKit = vars.texto;

        this.carregandoService.esconde('textoMonteSeuKit');
      },
      (erro) => {
        this.carregandoService.esconde('textoMonteSeuKit');
        this.notificacaoService.erro(erro);
      }
    );
  }

  buscarRegraValidacaoKitPersonalizado() {
    this.carregandoService.mostra('buscarRegraValidacaoKitPersonalizado');
    this.premissasService.consultarRegraValidacaoKitPersonalizado().subscribe(f => {
      this.regraValidacaoKitPersonalizado = f.valor;
      this.carregandoService.esconde('buscarRegraValidacaoKitPersonalizado');
    }, (erro) => {
      this.carregandoService.esconde('buscarRegraValidacaoKitPersonalizado');
      this.notificacaoService.erro(erro);
    });
  }

  buscarPermissoesFuncionario() {
    this.carregandoService.mostra('buscarPermissoesFuncionario');
    this.funcionarioService.consultarPermissoesPedido().subscribe(f => {
      this.permissoesPedidoFuncionario = f;

      this.carregandoService.esconde('buscarPermissoesFuncionario');
    }, (erro) => {
      this.carregandoService.esconde('buscarPermissoesFuncionario');
      this.notificacaoService.erro(erro);
    });
  }

  buscarPremissaUsarAcrescimo() {
    this.carregandoService.mostra('buscarPremissaUsarAcrescimo');
    this.premissasService.consultarUsarAcrescimo().subscribe(f => {
      if (f.valor) {
        this.pUsarAcrescimo = true;
      }

      this.carregandoService.esconde('buscarPremissaUsarAcrescimo');
    }, (erro) => {
      this.carregandoService.esconde('buscarPremissaUsarAcrescimo');
      this.notificacaoService.erro(erro);
    });
  }

  buscarPremissaOcultarColunaDescricaoFileiras() {
    this.carregandoService.mostra('buscarPremissaOcultarColunaDescricaoFileiras');
    this.premissasService.consultarOcultarColunaDescricaoFileiras().subscribe(f => {
      if (f.valor) {
        this.pOcultarColunaDescricaoFileiras = true;
      }

      this.carregandoService.esconde('buscarPremissaOcultarColunaDescricaoFileiras');
    }, (erro) => {
      this.carregandoService.esconde('buscarPremissaOcultarColunaDescricaoFileiras');
      this.notificacaoService.erro(erro);
    });
  }

  async buscarPremissaCalculadora() {

    try {
      this.carregandoService.mostra('buscarPremissaCalculadora');

      this.telhadoNaCalculadora = (await this.premissasService.consultarTelhadaNaCalculadora().toPromise()).valor;

      this.carregandoService.esconde('buscarPremissaCalculadora');
    } catch (erro) {
      this.carregandoService.esconde('buscarPremissaCalculadora');
      this.notificacaoService.erro(erro);
    }
  }


  async buscarPremissaCalcValorFinalSugestao() {

    try {
      this.carregandoService.mostra('buscarPremissaCalcValorFinalSugestao');

      this.calcValorFinalSugestao = (await this.premissasService.consultarCalcValorFinalSugestao().toPromise()).valor;

      this.carregandoService.esconde('buscarPremissaCalcValorFinalSugestao');
    } catch (erro) {
      this.carregandoService.esconde('buscarPremissaCalcValorFinalSugestao');
      this.notificacaoService.erro(erro);
    }
  }

  async calcularValorFinal() {

    try {
      this.carregandoService.mostra('buscarPremissaCalcValorFinalSugestao');

      const percentual = this.orcamento.descontoIndividual ?
        ((100 * (this.orcamento.valorTotal - this.orcamento.valorTotalItensComDesconto)) / this.orcamento.valorTotal) :
        (this.pUsarAcrescimo && this.cliente.daGI === 1 ? this.cliente.acrescimoGI : undefined);
      const valorDa = this.orcamento.descontoIndividual ?
        Number((this.orcamento.valorTotal - this.orcamento.valorTotalItensComDesconto).toFixed(2)) :
        (this.pUsarAcrescimo && this.cliente.daGI === 1 ? Number((Number(this.orcamento.valorTotal) * this.cliente.acrescimoGI / 100).toFixed(2)) : this.orcamento.valorDa);

      const idFornecedor = this.pCentroDistribuicao ? this.cliente.idCD :
        (this.multiFornecedores && this.orcamento.painelProduto !== null && this.orcamento.painelProduto !== undefined ? this.orcamento.painelProduto.idFornecedor : null);

      this.valorFinal = (await this.pedidoService.calcularValorFinal(!this.integrador ? this.cliente.id : this.usuarioLogado.id, 0, this.orcamento.valorTotal, idFornecedor, this.potSistema, this.orcamento.descontoIndividual, percentual, valorDa, this.cidadeSelecionado).toPromise());

      if (this.orcamento.descontoIndividual) {
        this.valorFinalSemDescontoIndividual = (await this.pedidoService.calcularValorFinal(!this.integrador ? this.cliente.id : this.usuarioLogado.id, 0, this.itens.reduce((acc, curr) => (acc + (curr.pUnitario * curr.qt)), 0), idFornecedor, this.potSistema, true, 0, 0, this.cidadeSelecionado).toPromise());
      }

      this.carregandoService.esconde('buscarPremissaCalcValorFinalSugestao');
    } catch (erro) {
      this.carregandoService.esconde('buscarPremissaCalcValorFinalSugestao');
      this.notificacaoService.erro(erro);
    }
  }

  // atualiza o tabIndex
  proximaTab() {
    this.tabIndex++;
  }

  tabAnterior() {
    this.tabIndex--;
  }

  retornaClasseTipoProduto(tipo) {
    switch (tipo.toString()) {
      case '2':
        return 'badge-primary';
      case '3':
        return 'badge-secondary';
      case '4':
        return 'badge-success';
      case '5':
        return 'badge-danger';
      case '6':
        return 'badge-dark';
      case '1':
        return 'badge-info';
      case '8':
        return 'badge-warning';
      case '9':
        return 'badge-danger';

      default:
        return 'badge-info';
    }
  }

  retornaLetraTipoProduto(tipo) {
    switch (tipo.toString()) {
      case '2':
        return 'P';
      case '3':
        return 'I';
      case '4':
        return 'S';
      case '5':
        return 'C';
      case '6':
        return 'E';
      case '1':
        return 'O';
      case '7':
        return 'K';
      case '8':
        return 'T';
      case '9':
        return 'B';

      default:
        return 'O';
    }
  }

  retornaOrdemTipoProduto(tipo) {
    switch (tipo.toString()) {
      case '7':
        return 0;
      case '2':
        return 1;
      case '3':
        return 2;
      case '4':
        return 3;
      case '5':
        return 4;
      case '6':
        return 5;
      case '8':
        return 6;
      case '1':
        return 7;

      default:
        return 6;
    }
  }

  compare(a: number | string, b: number | string, isAsc: boolean) {

    if (typeof a === 'string') {
      a = a.toLowerCase();
    }

    if (typeof b === 'string') {
      b = b.toLowerCase();
    }

    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  ordenaProdutos() {
    this.carregandoService.mostra('ordenaProduto');
    this.itens = this.itens.sort((a, b) => {
      return this.compare(this.retornaOrdemTipoProduto(a.produtoTela.familia), this.retornaOrdemTipoProduto(b.produtoTela.familia), true);
    });

    this.area = 0;

    if (this.itens.some(i => i.produtoTela.familia === 2)) {
      this.itens.map(i => {
        if (i.produtoTela.familia === 2) {
          this.area += (i.produtoTela.tamanho * i.qt);
        }
      });
    }

    this.carregandoService.esconde('ordenaProduto');
  }

  async ngOnInit() {
    const userId = await (await this.globalService.consultaUsuario()).id;
    this.usuarioLogado = await this.globalService.consultaUsuario();
    this.administrador = await this.globalService.administrador();
    this.integrador = await this.globalService.integrador();

    this.orcamento.dispEstoque = true;

    await this.buscarPremissasSistema();
    await this.buscarPremissasUsuario();

    if (this.premissasSistema.usarPrecificacaoPorUF) {
      await this.buscarPrecificacoesUF();

      this.descAcresPrecificacaoUF = this.precificacoesUF.some(p => p.uf === this.estadoSelecionado) ?
        this.precificacoesUF.find(p => p.uf === this.estadoSelecionado) : { percentual: 0, uf: '', tipoDa: 0 };
    }

    this.buscarNomeMenu();
    this.buscarPremissasBloqueioSistema();
    this.buscarPremissaOcultarColunaDescricaoFileiras();
    this.buscarPremissaUsarAcrescimo();
    this.buscarRegraValidacaoKitPersonalizado();
    this.buscarExibirLembreteMontarKitVertys();
    this.buscarPremissaVendaProgramada();

    await this.buscarPremissaCalculadora();
    await this.buscarPremissaCalcValorFinalSugestao();

    await this.buscarPremissaRemoverItemSugEdicao();
    this.consultaPodeVerEstoque(userId);


    if (!this.integrador) {
      this.buscarPermissoesFuncionario();
    }

    await this.buscarPremissaCentroDeDistribuicao();

    if (this.pCentroDistribuicao) {
      await this.buscarIntPodeAlterarCD();

      if (this.intPodeAlterarCD) {
        await this.buscarMostrarMsgTrocaCD();
      }
    }

    this.buscarCalculoGeracao();
    this.verificaPaineisEstrutura();

    const pAll = this.fileiras.map((forn: any): Promise<any> => {
      return new Promise((res, rej) => {
        try {
          if (forn.idFornecedorEstrutura !== null && forn.idFornecedorEstrutura !== undefined) {
            forn.logo$ = this.fornecedorEstruturaService.consultarImagemPorId(forn.idFornecedorEstrutura)
              .map(m => m !== null && m !== undefined ? this.utilitarioService.toBase64ComInicio(m) : Promise.resolve('')).toPromise();
            forn.logo$.then(p => { forn.buscouImagem = true; res(); }).catch(err => { res() });
          } else {
            res();
          }
        } catch (err) {
          rej(err);
        }
      });
    });

    await Promise.all(pAll);
  }

  async buscarPremissasUsuario() {
    try {
      this.carregandoService.mostra('buscarPremissasUsuario');
      this.premissasUsuario = await this.premissasService.consultarPremissasUsuario().toPromise();
    } catch (erro) {
      this.notificacaoService.erro(erro);
    } finally {
      this.carregandoService.esconde('buscarPremissasUsuario');
    }
  }

  consultaPodeVerEstoque(id: number) {
    this.carregandoService.mostra('podeVerEstoque');
    this.funcionarioService.consultaPodeVerEstoque(id).subscribe(resp => {
      this.podeVerEstoque = resp;
      this.carregandoService.esconde('podeVerEstoque');
    }, (erro) => {
      this.carregandoService.esconde('podeVerEstoque');
      console.error(erro);
      this.notificacaoService.erro('Não foi possível verificar se o usuário pode ver o estoque.');
    });
  }

  async buscarPremissaCentroDeDistribuicao() {
    try {
      this.carregandoService.mostra('buscarPremissaCentroDeDistribuicao');

      this.pCentroDistribuicao = (await this.premissasService.consultarCentroDeDistribuicao().toPromise()).valor;

      this.carregandoService.esconde('buscarPremissaCentroDeDistribuicao');
    } catch (erro) {
      this.carregandoService.esconde('buscarPremissaCentroDeDistribuicao');
      this.notificacaoService.erro(erro);
    }
  }

  async buscarIntPodeAlterarCD() {

    try {
      this.carregandoService.mostra('buscarIntPodeAlterarCD');

      this.intPodeAlterarCD = (await this.premissasService.consultarIntPodeAlterarCD().toPromise()).valor;

      this.carregandoService.esconde('buscarIntPodeAlterarCD');
    } catch (erro) {
      this.carregandoService.esconde('buscarIntPodeAlterarCD');
      this.notificacaoService.erro(erro);
    }
  }

  async buscarMostrarMsgTrocaCD() {

    try {
      this.carregandoService.mostra('buscarMostrarMsgTrocaCD');

      this.mostrarMsgTrocaCD = await this.premissasService.consultarMostrarMsgTrocaCD().toPromise();

      this.carregandoService.esconde('buscarMostrarMsgTrocaCD');
    } catch (erro) {
      this.carregandoService.esconde('buscarMostrarMsgTrocaCD');
      this.notificacaoService.erro(erro);
    }
  }

  pesquisarCliente() {
    const dialogRef = this.dialog.open(ClientesModalComponent, {
      width: ($('body').width()).toString() + 'px',
      data: {
        gi: 1,
        esconderBotao: true
      },
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe((result: { cliente: Cliente, vendedor: any, limDesc: any }) => {
      if (result) {
        this.descontoFrete = result.cliente.descFrete;
        this.cliente = result.cliente;
        this.clienteIntegrador = result.cliente;
        this.descontoMaximo = result.limDesc ? result.limDesc : this.usuarioLogado.limDesc;
        this.limDesc = result.limDesc;

        // this.buscarDescontoPadrao();
        // if (!this.calculadora) {
        //   if (this.tipo === 0) {
        //     this.estadoSelecionado = this.clienteIntegrador.uf;
        //     this.buscarCidadeIntegrador();
        //   }
        //   else {
        //     this.copiaEnderecoIntegrador();
        //   }
        // }
        // else if (this.tipoEndereco === 0) {
        //   this.copiaEnderecoIntegrador();
        // }
      }
    }
    );
  }

  buscarDados() {
    this.buscarEstruturasPersonalizadas();

    this.carregandoService.mostra('buscarUsarCombInvStrCon');
    this.premissasService.consultarUsarCombInvStrCon().subscribe(f => {

      this.usarCombInvStrCon = f.valor;
      this.carregandoService.esconde('buscarUsarCombInvStrCon');


      this.buscarUsarCombImp();
      this.buscarMostrarBifasico();
      this.buscarVerPrecosProdutos();
      this.buscarMostrarCodErp();
      this.descontoMaximo = this.integrador ? 0 : this.usuarioLogado.limDesc;

      if (this.cliente.descontoMaximoGI > this.descontoMaximo) {
        this.descontoMaximo = this.cliente.descontoMaximoGI;
      }

      this.verCustos = this.usuarioLogado.verCustos;

      this.titulo = 'Personalize seu kit';

      this.texto = 'Orçamento';
      this.verificaValidacaoKit();

      if (this.integrador) {
        this.inserirLogAcessoTela();
      }

      this.carregandoService.mostra('buscarMultiFornecedores');
      this.premissasService.consultarMultiFornecedores().subscribe(async f => {
        this.multiFornecedores = f.valor;

        if (this.semState && this.multiFornecedores) {
          this.router.navigate(['/']);
        }

        this.orcamento.obs2 = '';

        this.itens = [];
        this.orcamento.data = new Date();
        this.orcamento.da = 0;
        this.orcamento.valorDa = 0;
        this.orcamento.percentual = 0;
        this.orcamento.flag = 4;
        this.clienteFaturamento.tipo = 0;
        this.orcamento.cupomDesconto = null;
        this.orcamento.tipoFrete = 0;
        this.orcamento.frete = 0;
        this.orcamento.valorServico = 0;
        this.orcamento.financiamento = true;

        if (this.orcamento.painel === null || this.orcamento.painel === undefined) {
          this.orcamento.painel = this.painel;
        }
        if (this.orcamento.fase === null || this.orcamento.fase === undefined) {
          this.orcamento.fase = this.fase;
        }
        if (this.orcamento.tensao === null || this.orcamento.tensao === undefined) {
          this.orcamento.tensao = this.tensao;
        }

        if (this.painel !== null && this.painel !== undefined && this.quantidadeDePaineis > 0) {
          const novoItem = new ItemPedido();
          novoItem.produto = this.orcamento.painelProduto.idProduto;
          novoItem.qt = this.quantidadeDePaineis;
          novoItem.qtSugerida = this.quantidadeDePaineis;
          novoItem.pUnitario = this.orcamento.painelProduto.precoVenda;
          novoItem.vTotal = novoItem.qt * novoItem.pUnitario;
          novoItem.situacaoProduto = this.orcamento.painelProduto.situacao;
          novoItem.qtAnterior = novoItem.qt;
          novoItem.produtoTela = this.orcamento.painelProduto;
          novoItem.det1 = this.orcamento.painelProduto.descricaoAtual;
          novoItem.pVendaOriginal = novoItem.pUnitario;
          this.itens.push(novoItem);
          this.ordenaProdutos();
          await this.atualizaValorProduto(novoItem);
          this.carregandoService.esconde('buscaPaineis');
        }

        if (this.telhado !== null && this.telhado !== undefined && !this.comEstrutura) {
          if (this.telhado !== -1) {
            this.novaFileira.fileiras = 1;
            this.novaFileira.numPaineis = this.quantidadeDePaineis;
            this.novaFileira.telhado = this.telhado;
            this.novaFileira.orientacao = 'retrato';
            this.novaFileira.larguraPainel = this.larguraPainel;
            this.novaFileira.comprimentoPainel = this.comprimentoPainel;
            this.novaFileira.alturaPainel = this.alturaPainel;
            this.novaFileira.referenciaPainel = this.orcamento.painelProduto.referencia;
            this.novaFileira.uf = this.ufInstalacao;

            if (this.multiFornecedores) {
              this.novaFileira.idFornecedorPainel = this.orcamento.painelProduto.idFornecedor;
            }

            if (this.pCentroDistribuicao) {
              this.novaFileira.idFornecedorPainel = this.cliente.idCD;
            }

            this.carregandoService.mostra('buscarFornecedores');
            this.pedidoService.buscarFornecedoresEstrutura(this.novaFileira).subscribe(async resp => {
              this.fornecedoresDisponiveis = resp;

              this.fornecedoresDisponiveis.forEach((forn: any) => {
                if (forn.idFornecedorEstrutura !== null && forn.idFornecedorEstrutura !== undefined) {
                  forn.logo$ = this.fornecedorEstruturaService.consultarImagemPorId(forn.idFornecedorEstrutura)
                    .map(m => m !== null && m !== undefined ? this.utilitarioService.toBase64ComInicio(m) : Promise.resolve('')).toPromise();
                  forn.logo$.then(p => { forn.buscouImagem = true; });
                }
              });


              // if (this.fornecedoresUtilizados.length > 0 && this.fornecedoresUtilizados.some(p => p !== null && p !== undefined)) {
              //   this.fornecedoresDisponiveis = this.fornecedoresDisponiveis.filter(p => this.fornecedoresUtilizados.some(u => u === p.fornecedor));
              // }

              let forn = this.fornecedoresDisponiveis.find(f => f.fornecedor === this.fornecedorSelecionado);
              let vTotal = 0;
              if (forn === undefined || forn === null) {
                this.novaFileira.fornecedor = null;
                this.novaFileira.itens = [];
              }
              else {
                this.novaFileira.fornecedor = forn.fornecedor;
                this.novaFileira.itens = forn.itens;
                this.novaFileira.itens.map((f) => {
                  vTotal += f.vTotal;
                });
              }
              this.novaFileira.valorTotal = vTotal;

              this.fileiras.push(this.novaFileira);
              // this.calcularQtdPaineis();
              await this.buscarItensEstrutura(null, true);
              this.kitsSugeridos(1);
              // this.carregandoService.esconde('buscarFornecedores');
              // buscarCliente
            }, (erro) => {
              this.carregandoService.esconde('buscarFornecedores');
              this.notificacaoService.erro(erro);
            });
          }
          else {
            // this.novaFileira.fornecedor = null;
            // this.novaFileira.itens = [];
            // this.fileiras.push(this.novaFileira);
            await this.buscarItensEstrutura(null, true);
            this.kitsSugeridos(2);
          }
        } else {
          await this.buscarItensEstrutura(null, true);

          this.kitsSugeridos(3);
        }


        if (this.integrador) {
          this.orcamento.cliente = this.usuarioLogado.id;
          this.buscarCliente();
        }
        else {
          this.vendedorSelecionado = this.vendedor ? this.vendedor.idFuncion : this.usuarioLogado.id;
        }

        this.carregandoService.esconde('buscarMultiFornecedores');
      }, (erro) => {
        this.carregandoService.esconde('buscarMultiFornecedores');
        this.notificacaoService.erro(erro);
      });

    }, (erro) => {
      this.carregandoService.esconde('buscarUsarCombInvStrCon');
      this.notificacaoService.erro(erro);
    });





    const elemMainPanel = <HTMLElement>document.querySelector('.main-panel');

    // Wizard Initialization
    $('.wizard-pedido').bootstrapWizard({
      'tabClass': 'nav nav-pills',
      'nextSelector': '.btn-next',
      'previousSelector': '.btn-previous',

      onNext: function (tab, navigation, index) {
      },

      onInit: function (tab: any, navigation: any, index: any) {

        // check number of tabs and fill the entire row
        let $total = navigation.find('li').length;
        let $wizard = navigation.closest('.wizard-pedido');

        let $first_li = navigation.find('li:first-child a').html();
        let $moving_div = $('<div class="moving-tab">' + $first_li + '</div>');
        $('.wizard-pedido .wizard-navigation').append($moving_div);

        $total = $wizard.find('.nav li').length;
        let $li_width = 100 / $total;

        let total_steps = $wizard.find('.nav li').length;
        let move_distance = $wizard.width() / total_steps;
        let index_temp = index;
        let vertical_level = 0;

        let mobile_device = $(document).width() < 600 && $total > 3;

        if (mobile_device) {
          move_distance = $wizard.width() / 2;
          index_temp = index % 2;
          $li_width = 50;
        }

        $wizard.find('.nav li').css('width', $li_width + '%');

        let step_width = move_distance;
        move_distance = move_distance * index_temp;

        let $current = index + 1;

        if ($current == 1 || (mobile_device == true && (index % 2 == 0))) {
          move_distance -= 8;
        } else if ($current == total_steps || (mobile_device == true && (index % 2 == 1))) {
          move_distance += 8;
        }

        if (mobile_device) {
          let x: any = index / 2;
          vertical_level = parseInt(x);
          vertical_level = vertical_level * 38;
        }

        $wizard.find('.moving-tab').css('width', step_width);
        $('.moving-tab').css({
          'transform': 'translate3d(' + move_distance + 'px, ' + vertical_level + 'px, 0)',
          'transition': 'all 0.5s cubic-bezier(0.29, 1.42, 0.79, 1)'

        });
        $('.moving-tab').css('transition', 'transform 0s');
      },

      onTabClick: (tab: any, navigation: any, index: any) => {
        return false;
      },

      onTabShow: function (tab: any, navigation: any, index: any) {
        let $total = navigation.find('li').length;
        let $current = index + 1;
        elemMainPanel.scrollTop = 0;
        const $wizard = navigation.closest('.wizard-pedido');

        // If it's the last tab then hide the last button and show the finish instead
        if ($current >= $total) {
          $($wizard).find('.btn-next').hide();
          $($wizard).find('.btn-finish').show();
        } else {
          $($wizard).find('.btn-next').show();
          $($wizard).find('.btn-finish').hide();
        }

        const button_text = navigation.find('li:nth-child(' + $current + ') a').html();

        setTimeout(function () {
          $('.wizard-pedido .moving-tab').text(button_text);
        }, 150);

        const checkbox = $('.footer-checkbox');

        if (index !== 0) {
          $(checkbox).css({
            'opacity': '0',
            'visibility': 'hidden',
            'position': 'absolute'
          });
        } else {
          $(checkbox).css({
            'opacity': '1',
            'visibility': 'visible'
          });
        }
        $total = $wizard.find('.nav li').length;
        let $li_width = 100 / $total;

        let total_steps = $wizard.find('.nav li').length;
        let move_distance = $wizard.width() / total_steps;
        let index_temp = index;
        let vertical_level = 0;

        let mobile_device = $(document).width() < 600 && $total > 3;

        if (mobile_device) {
          move_distance = $wizard.width() / 2;
          index_temp = index % 2;
          $li_width = 50;
        }

        $wizard.find('.nav li').css('width', $li_width + '%');

        let step_width = move_distance;
        move_distance = move_distance * index_temp;

        $current = index + 1;

        if ($current == 1 || (mobile_device == true && (index % 2 == 0))) {
          move_distance -= 8;
        } else if ($current == total_steps || (mobile_device == true && (index % 2 == 1))) {
          move_distance += 8;
        }

        if (mobile_device) {
          let x: any = index / 2;
          vertical_level = parseInt(x);
          vertical_level = vertical_level * 38;
        }

        $wizard.find('.moving-tab').css('width', step_width);
        $('.moving-tab').css({
          'transform': 'translate3d(' + move_distance + 'px, ' + vertical_level + 'px, 0)',
          'transition': 'all 0.5s cubic-bezier(0.29, 1.42, 0.79, 1)'

        });
      }
    });


    // Prepare the preview for profile picture
    $('#wizard-picture').change(function () {
      const input = $(this);

      if (input[0].files && input[0].files[0]) {
        const reader = new FileReader();

        reader.onload = function (e: any) {
          $('#wizardPicturePreview').attr('src', e.target.result).fadeIn('slow');
        };
        reader.readAsDataURL(input[0].files[0]);
      }
    });

    $('[data-toggle="wizard-radio"]').click(function () {
      const wizard = $(this).closest('.wizard-pedido');
      wizard.find('[data-toggle="wizard-radio"]').removeClass('active');
      $(this).addClass('active');
      $(wizard).find('[type="radio"]').removeAttr('checked');
      $(this).find('[type="radio"]').attr('checked', 'true');
    });

    $('[data-toggle="wizard-checkbox"]').click(function () {
      if ($(this).hasClass('active')) {
        $(this).removeClass('active');
        $(this).find('[type="checkbox"]').removeAttr('checked');
      } else {
        $(this).addClass('active');
        $(this).find('[type="checkbox"]').attr('checked', 'true');
      }
    });

    $('.set-full-height').css('height', 'auto');

  }

  ngAfterViewInit() {


    $(window).resize(() => {

      $('.wizard-pedido').each(function () {
        setTimeout(() => {
          const $wizard = $(this);
          const index = $wizard.bootstrapWizard('currentIndex');
          let $total = $wizard.find('.nav li').length;
          let $li_width = 100 / $total;

          let total_steps = $wizard.find('.nav li').length;
          let move_distance = $wizard.width() / total_steps;
          let index_temp = index;
          let vertical_level = 0;

          let mobile_device = $(document).width() < 600 && $total > 3;
          if (mobile_device) {
            move_distance = $wizard.width() / 2;
            index_temp = index % 2;
            $li_width = 50;
          }

          $wizard.find('.nav li').css('width', $li_width + '%');

          let step_width = move_distance;
          move_distance = move_distance * index_temp;

          let $current = index + 1;

          if ($current == 1 || (mobile_device == true && (index % 2 == 0))) {
            move_distance -= 8;
          } else if ($current == total_steps || (mobile_device == true && (index % 2 == 1))) {
            move_distance += 8;
          }

          if (mobile_device) {
            let x: any = index / 2;
            vertical_level = parseInt(x);
            vertical_level = vertical_level * 38;
          }

          $wizard.find('.moving-tab').css('width', step_width);
          $('.moving-tab').css({
            'transform': 'translate3d(' + move_distance + 'px, ' + vertical_level + 'px, 0)',
            'transition': 'all 0.5s cubic-bezier(0.29, 1.42, 0.79, 1)'
          });

          $('.moving-tab').css({
            'transition': 'transform 0s'
          });
        }, 500);

      });
    });

    this.utilitarioService.rodaScriptTabEnter();

  }

  // abre o modal de pesquisa de produtos
  pesquisarProdutos() {
    let idFornecedorPainel;

    if (this.pCentroDistribuicao) {
      idFornecedorPainel = this.cliente.idCD;
    }

    if (this.multiFornecedores) {
      idFornecedorPainel = this.orcamento.painelProduto.idFornecedor;
    }

    let dialogRef;
    const config = {
      width: ($('body').width()).toString() + 'px',
      // passa os produtos já selecionados
      data: {
        descAcresPrecificacaoUF: this.descAcresPrecificacaoUF,
        selecionavel: true,
        produtos: this.itens,
        somenteKit: false,
        quantidadeDePaineis: this.quantidadeDePaineis,
        potenciaPainel: this.potenciaPainel,
        potTotal: this.potTotal,
        mostrarCabecalho: this.potTotal ? true : false,
        semKit: true,
        idFornecedorPainel: idFornecedorPainel,
        msgAlterarCD: this.integrador && this.intPodeAlterarCD && this.pCentroDistribuicao && this.cliente && this.mostrarMsgTrocaCD.valor && this.mostrarMsgTrocaCD.msg ? this.mostrarMsgTrocaCD.msg : undefined,
        somenteMSK: true,
        origem: 0
      },
      panelClass: 'modal-card',
      // maxHeight: '90vh'
    };

    if (this.premissasSistema.filtroProduto === TipoFiltroProduto.Agrupamento) {
      dialogRef = this.dialog.open(ProdutosModalComponent, config);
    } else {
      dialogRef = this.dialog.open(ProdutosV2ModalComponent, config);
    }

    // quando fecha o modal
    dialogRef.afterClosed().subscribe(async (result: ItemPedido[]) => {
      if (result) {

        result.forEach(i => {
          if (i.valorDa === null || i.valorDa === undefined || isNaN(i.valorDa)) {
            i.valorDa = 0;
          }
          if (i.percentual === null || i.percentual === undefined || isNaN(i.percentual)) {
            i.percentual = 0;
          }
        });

        // verifica se é para excluir algum item
        if (this.itens.some(p => !result.some(r => r.produtoTela.idProduto === p.produtoTela.idProduto))) {
          this.itens.filter(p => !result.some(r => r.produtoTela.idProduto === p.produtoTela.idProduto)).forEach(async it => {
            await this.excluirProduto(it);
          });
        }

        // atualiza a lista de produtos

        for await (const p of result) {
          if (this.itens.some(ps => ps.produtoTela.idProduto === p.produtoTela.idProduto)) {
            this.itens.find(ps => ps.produtoTela.idProduto === p.produtoTela.idProduto).qt = p.qt;
            await this.atualizaValorProduto(this.itens.find(ps => ps.produtoTela.idProduto === p.produtoTela.idProduto));
          } else {
            this.itens.push(p);
            this.ordenaProdutos();
            await this.atualizaValorProduto(p);
          }
        }

        // result.forEach(async p => {
        //   if (this.itens.some(ps => ps.produtoTela.idProduto === p.produtoTela.idProduto)) {
        //     this.itens.find(ps => ps.produtoTela.idProduto === p.produtoTela.idProduto).qt = p.qt;
        //     await this.atualizaValorProduto(this.itens.find(ps => ps.produtoTela.idProduto === p.produtoTela.idProduto));
        //   } else {
        //     this.itens.push(p);
        //     this.ordenaProdutos();
        //     await this.atualizaValorProduto(p);
        //   }
        // });

      }
    }
    );
  }

  descontoIndividual(item: ItemPedido) {

    const largura = Number(($('body').width()));

    const valorTotalItens = this.itens.reduce((acc, curr) => (acc + (Number(curr.pUnitario) * Number(curr.qt))), 0);
    const valorTotalItensComDesconto = this.itens.filter(p => p !== item).reduce((acc, curr) => (acc + curr.vTotal), 0);

    const dialogRef = this.dialog.open(DescontoIndividualModalComponent, {
      width: largura > 630 ? '600px' : (($('body').width()).toString() + 'px'),
      data: { valor: Number(item.pUnitario) * Number(item.qt), desconto: item.valorDa, percentual: item.percentual, valorTotalItens: valorTotalItens, valorTotalItensComDesconto: valorTotalItensComDesconto, descontoMaximo: this.descontoMaximo },
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe(async (result) => {
      if (result) {

        if (result.aplicarParaTodos) {

          this.itens.forEach(p => {
            p.valorDa = Number(((Number(p.pUnitario) * Number(p.qt) * Number(result.percentual)) / 100).toFixed(2));
            p.percentual = Number(result.percentual);
            p.vTotal = Number(((Number(p.pUnitario) * Number(p.qt)) - p.valorDa).toFixed(2));
          });

          await this.atualizaDesconto(0, true);

        } else {

          if (Number(item.valorDa) !== Number(result.desconto) ||
            Number(item.percentual) !== Number(result.percentual) ||
            Number(item.vTotal) !== Number(result.valor)) {



            item.valorDa = Number(result.desconto);
            item.percentual = Number(result.percentual);
            item.vTotal = Number(result.valor);

            await this.atualizaValores();
          }
        }
      }
    });
  }

  async validaQtd(item: ItemPedido) {

    if (item.qt === null || item.qt === undefined || Number.isNaN(item.qt) || item.qt < 0) {
      item.qt = 1;
      await this.atualizaValorProduto(item);
    } else if (Number(item.qt) > 200000) {
      item.qt = 200000;
      await this.atualizaValorProduto(item);
    }
  }

  /*calcularSimulacao() {
    let quantidadeDePaineis = 0;
    let potenciaPainel = 0;

    if (this.itens && this.itens.some(p => p.produtoTela.familia === 2 || p.produtoTela.familia === 7)) {
      if(this.itens.some(p => p.produtoTela.familia === 2)) {
        const pPainel = this.itens.find(p => p.produtoTela.familia === 2);
        potenciaPainel = pPainel.produtoTela.potencia;
        quantidadeDePaineis = pPainel.qt;
      }
      else {
        this.itens.filter(p => p.produtoTela.familia === 7).forEach(i => {
          potenciaPainel += i.produtoTela.potencia * i.qt;
        });
        quantidadeDePaineis = 1;
      }
    }
    else {
      potenciaPainel = this.potenciaPainel;
    }

    this.potSistema = undefined;
    let potTotal = 0;

    potTotal = Number(
      ((potenciaPainel * quantidadeDePaineis)/ 1000).toFixed(2)
    );

    if(isNaN(potTotal)) {
      potTotal = null;
    }

    if(!this.itens.some(p => p.produtoTela.familia === 2 || p.produtoTela.familia === 7)) {
      this.potTotal = potTotal;
      this.potSistema = potTotal;
    } else {
      this.potSistema = potTotal;
    }
  }*/

  buscarIrradiacao() {
    this.carregandoService.mostra('buscaIrradiacao');
    this.irradiacaoService.buscarPorIbge(this.cidadeSelecionado).subscribe(
      (irr) => {
        this.irradiacao = irr;

        if (this.irradiacao && this.irradiacao.idirrad) {
          this.latitude = this.irradiacao.lat.replace('.', ',');
          this.longitude = this.irradiacao.lon.replace('.', ',');
        }

        this.buscarDados();

        this.carregandoService.esconde('buscaIrradiacao');
      },
      (erro) => {
        this.carregandoService.esconde('buscaIrradiacao');

        this.notificacaoService.erro(erro);
      }
    );
  }

  buscarCalculoGeracao() {
    this.carregandoService.mostra('buscaCalculoGeracao');
    this.pedidoService.calculoGeracao().subscribe(
      (calculo) => {
        this.calculoGeracao.numeroDiasMes = calculo.numeroDiasMes;
        this.calculoGeracao.eficienciaDoPainel = calculo.eficienciaDoPainel;
        this.buscarIrradiacao();

        this.carregandoService.esconde('buscaCalculoGeracao');
      },
      (erro) => {
        this.carregandoService.esconde('buscaCalculoGeracao');

        this.notificacaoService.erro(erro);
      }
    );
  }

  calcularSimulacao() {
    const usarItens = true;

    let quantidadeDePaineis = 0;
    // calcula energia fornecida e aplica perdas
    const energiasMeses: number[] = [];

    const irradiacoes = [
      this.irradiacao.jan,
      this.irradiacao.fev,
      this.irradiacao.mar,
      this.irradiacao.abr,
      this.irradiacao.mai,
      this.irradiacao.jun,
      this.irradiacao.jul,
      this.irradiacao.ago,
      this.irradiacao.set,
      this.irradiacao.out,
      this.irradiacao.nov,
      this.irradiacao.dez,
    ];

    let potenciaPainel = 0;
    if (usarItens && this.itens && this.itens.some(p => p.produtoTela.familia === 2 || p.produtoTela.familia === 7)) {
      if (this.itens.some(p => p.produtoTela.familia === 2)) {
        const pPainel = this.itens.find(p => p.produtoTela.familia === 2);
        potenciaPainel = pPainel.produtoTela.potencia;
        quantidadeDePaineis = Number(pPainel.qt);
      }
      else {
        this.itens.filter(p => p.produtoTela.familia === 7).forEach(i => {
          potenciaPainel += i.produtoTela.potencia * Number(i.qt);
        });
        quantidadeDePaineis = 1;
      }
    }
    else {
      potenciaPainel = this.potenciaPainel;
    }
    irradiacoes.forEach((p) =>
      energiasMeses.push(
        (potenciaPainel *
          this.calculoGeracao.eficienciaDoPainel *
          p *
          this.calculoGeracao.numeroDiasMes) /
        1000 -
        ((potenciaPainel *
          this.calculoGeracao.eficienciaDoPainel *
          p *
          this.calculoGeracao.numeroDiasMes) /
          1000) *
        (this.perdas / 100)
      )
    );
    // this.utilitarioService.retornaMeses(this.irradiacao).forEach(p =>
    //   energiasMeses.push(((this.simulacao.potenciaPainel * 0.8 * p * 30.4) / 1000) -
    //     (((this.simulacao.potenciaPainel * 0.8 * p * 30.4) / 1000) * (this.simulacao.perdas / 100))));

    if (this.percGeracao === null || this.percGeracao === undefined) {
      this.percGeracao = 100;
    }

    const potenciaComPercentual = Number(
      ((this.potenciaDesejada * Number(this.percGeracao)) / 100).toFixed(2)
    );

    let qtdNecessaria = 0;
    energiasMeses.forEach((p) => (qtdNecessaria += potenciaComPercentual / p));
    qtdNecessaria = qtdNecessaria / 12;
    if (qtdNecessaria < 1) {
      qtdNecessaria = 1;
    }
    this.producaoPorPainel = Number(
      (potenciaComPercentual / qtdNecessaria).toFixed(1)
    );

    // this.quantidadeDePaineis = Math.ceil(Number(qtdNecessaria.toFixed(1)));

    if (!usarItens || (!this.itens.some(p => p.produtoTela.familia === 2 || p.produtoTela.familia === 7))) {
      qtdNecessaria = 0;
      energiasMeses.forEach((p) => (qtdNecessaria += potenciaComPercentual / p));
      qtdNecessaria = qtdNecessaria / 12;
      this.producaoPorPainel = Number(
        (potenciaComPercentual / qtdNecessaria).toFixed(1)
      );
      // this.quantidadeDePaineis = Math.ceil(Number(qtdNecessaria.toFixed(1)));
      quantidadeDePaineis = Math.ceil(Number(qtdNecessaria.toFixed(1)));
    }

    let potTotal = 0;
    potTotal = Number(
      ((potenciaPainel * quantidadeDePaineis) / 1000).toFixed(2)
    );

    if (isNaN(potTotal)) {
      potTotal = null;
    }

    if (!usarItens || (!this.itens.some(p => p.produtoTela.familia === 2 || p.produtoTela.familia === 7))) {
      this.potTotal = potTotal;
      this.potSistema = potTotal;
    } else {
      this.potSistema = potTotal;
    }

    if (this.fileiras !== null && this.fileiras !== undefined && this.fileiras.length > 0) {
      this.fileiras.forEach(f => f.potenciaTotal = Number(this.potSistema));
    }

    let media = 0;
    let mediaSemPerda = 0;

    const meses = [];

    for (let i = 0; i < irradiacoes.length; i++) {
      const valorMes =
        ((irradiacoes[i] *
          potenciaPainel *
          this.calculoGeracao.eficienciaDoPainel *
          this.calculoGeracao.numeroDiasMes) /
          1000) *
        quantidadeDePaineis;

      meses[i] =
        ((irradiacoes[i] *
          potenciaPainel *
          this.calculoGeracao.eficienciaDoPainel *
          this.calculoGeracao.numeroDiasMes) /
          1000) *
        quantidadeDePaineis;

      mediaSemPerda += Number(Number(meses[i]).toFixed(0));

      meses[i] -= (valorMes * Number(this.perdas)) / 100;
      meses[i] = Number(meses[i]).toFixed(0).replace('.', ',');
      media += Number(meses[i].toString().replace(',', '.'));
    }

    // this.projeto.mediaFornSemPerda = (mediaSemPerda / 12).toFixed(0);

    this.fatorGeracao = media / 12;
  }


  async atualizaValorProduto(item: ItemPedido) {

    let descontar = false;
    let desconto = 0;

    if (this.calculadora)
      this.calcularSimulacao();

    if (item.qt !== item.qtAnterior) { // && Number(item.qt) > Number(item.produtoTela.qtestoque)) {
      item.alterado = true;
      item.qtAnterior = item.qt;
      if (item.produtoTela.familia === 2) {
        this.verificaPaineisEstrutura();
      }
    }

    if (item.produtoTela.familia === 2 || item.produtoTela.familia === 3) {
      desconto = await this.buscarDescontoProduto(item);
      descontar = true;
      item.itemDesc.preco = item.produtoTela.precoVenda;
    }

    item.pUnitario = descontar ?
      Number((item.produtoTela.precoVenda
        - ((item.produtoTela.precoVenda * desconto) / 100)).toFixed(2))
      :
      Number((item.produtoTela.precoVenda).toFixed(2));

    if (this.premissasSistema.usarPrecificacaoPorUF) {

      item.pUnitario = this.calcularPrecificacaoUF(item.pUnitario, this.descAcresPrecificacaoUF);
    }

    if (this.orcamento.descontoIndividual) {
      item.vTotal = Number(((item.pUnitario * item.qt)).toFixed(2));
      item.valorDa = Number(((item.vTotal * item.percentual) / 100).toFixed(2));
      item.vTotal = item.vTotal - item.valorDa;

      this.validarDescontoIndividual(item, true);
    } else {
      item.vTotal = Number((item.pUnitario * item.qt).toFixed(2));
    }

    await this.atualizaValores();

    if (this.usarCombInvStrCon && item.produtoTela.familia === 3 && item.alterado) {
      await this.buscarStringBoxConectorDoInversor(item.produto, item.qt, item.qtSugerida);
    }

    item.alterado = false;
  }

  async buscarDescontoProduto(item: ItemPedido) {
    try {
      this.carregandoService.mostra('buscarDescontoProduto');

      if (item.itemDesc === null || item.itemDesc === undefined)
        item.itemDesc = new ItemDesc();

      item.itemDesc.descontos = item.itemDesc.descontos === null || item.itemDesc.descontos === undefined ? await this.produtoService.consultarDescontos(item.produtoTela.idProduto).toPromise() : item.itemDesc.descontos;

      if (item.itemDesc.descontos.some(p => item.qt >= p.qtdIni &&
        item.qt <= p.qtdFim)) {
        this.carregandoService.esconde('buscarDescontoProduto');
        return item.itemDesc.descontos
          .find(p => item.qt >= p.qtdIni &&
            item.qt <= p.qtdFim).desco;
      } else {
        this.carregandoService.esconde('buscarDescontoProduto');
        return 0;
      }
    } catch (erro) {
      this.carregandoService.esconde('buscarDescontoProduto');
      this.notificacaoService.erro(erro);
      return 0;
    }
  }

  async aumentaQtdProduto(item: ItemPedido) {
    if (item.qt + 1 <= 10000) {
      item.qt = item.qt + 1;
    }

    await this.atualizaValorProduto(item);
  }

  async diminuiQtdProduto(item: ItemPedido) {
    if (item.qt && item.qt > 1) {
      item.qt = item.qt - 1;
      await this.atualizaValorProduto(item);
    }
  }

  async buscarPremissaRemoverItemSugEdicao() {

    try {
      this.carregandoService.mostra('buscarPremissaRemoverItemSugEdicao');

      this.removerItemSugEdicao = (await this.premissasService.consultarRemoverItemSugEdicao().toPromise()).valor;

      this.carregandoService.esconde('buscarPremissaRemoverItemSugEdicao');
    } catch (erro) {
      this.carregandoService.esconde('buscarPremissaRemoverItemSugEdicao');
      this.notificacaoService.erro(erro);
    }
  }

  async excluirProduto(item: ItemPedido, interno?: boolean) {
    if (/*!item.produtoTela.produtoEstrutura &&*/ ((!item.qtSugerida || this.removerItemSugEdicao) || interno)) {
      this.itens.splice(this.itens.indexOf(item), 1);
      await this.atualizaValores();
    } else {
      item.qt = 0;
      await this.atualizaValorProduto(item);
    }

    if (this.usarCombInvStrCon && item.produtoTela.familia === 3) {
      await this.buscarStringBoxConectorDoInversor(item.produto, 0, item.qtSugerida);
    }

    this.verificaPaineisEstrutura();
  }

  validarDescontoIndividual(item: ItemPedido, exibirMsg: boolean) {
    const valorTotalItens = this.itens.reduce((acc, curr) => (acc + (Number(curr.pUnitario) * Number(curr.qt))), 0);
    const valorTotalItensComDesconto = this.itens.reduce((acc, curr) => (acc + curr.vTotal), 0);


    if (item.valorDa > 0 && item.percentual > 0 && 100 * (valorTotalItens - valorTotalItensComDesconto) / valorTotalItens > this.descontoMaximo) {

      const valorDaMaximo = Number((valorTotalItens * this.descontoMaximo / 100).toFixed(2));
      const valorDaAtual = valorTotalItens - valorTotalItensComDesconto;
      const diferencaDa = valorDaAtual - valorDaMaximo;
      const valorItemSemDesconto = Number((Number(item.qt) * Number(item.pUnitario)).toFixed(2));
      const valorItem = item.vTotal + diferencaDa > valorItemSemDesconto ? valorItemSemDesconto : (item.vTotal + diferencaDa);
      const percentualItem = ((valorItemSemDesconto - valorItem) * 100) / valorItemSemDesconto;

      if (exibirMsg) {
        swal({
          title: 'ATENÇÃO!!',
          html: 'Desconto acima do permitido: <b>' + this.descontoMaximo.toLocaleString() + (this.nomeVendedor ? ('% </b><br/>Vendedor: ' + this.nomeVendedor) : ''),
          type: 'warning',
          confirmButtonClass: 'btn btn-warning',
          buttonsStyling: false,
          allowEnterKey: false
        }).then(async (result) => {
          item.percentual = percentualItem;
          item.valorDa = valorItemSemDesconto - valorItem;
          item.vTotal = valorItem;

          await this.atualizaValores();
          // this.atualizaDesconto(1, true);
        });
      } else {
        item.percentual = percentualItem;
        item.valorDa = valorItemSemDesconto - valorItem;
        item.vTotal = valorItem;
      }
    }
  }

  async atividaDesativaDescontoIndividual() {

    this.itens.forEach(p => {
      p.valorDa = 0;
      p.percentual = 0;
      p.vTotal = Number((Number(p.pUnitario) * Number(p.qt)).toFixed(2));
    });

    await this.atualizaValores();

    // this.atualizaDesconto(0, true);
  }

  async buscarItensEstrutura(itensCombinacao?: ItemPedido[], excluirItens?: boolean) {

    this.calcularQtdPaineis();

    const qtdPaineisLista = this.itens.filter(p => p.produtoTela.familia === 2).reduce((acc, curr) => (acc + curr.qt), 0);

    this.produtoEstruturaBloqueado = false;

    if (itensCombinacao !== null && itensCombinacao !== undefined) {
      if (itensCombinacao.some(p => p.situacaoProduto === 'B')) {
        this.produtoEstruturaBloqueado = true;
        swal({
          title: 'ATENÇÃO!!!',
          html: 'Existem produtos da estrutura que estão bloqueados!!!',
          buttonsStyling: false,
          confirmButtonClass: 'btn btn-warning',
          type: 'warning'
        }).catch(swal.noop);
      } else {

        if (this.itens && this.itens.some(p => !itensCombinacao.some(pi => pi.produto === p.produto))) {
          for (const item of this.itens.filter(p => !itensCombinacao.some(pi => pi.produto === p.produto))) {
            await this.excluirProduto(item, true);
          }
        }

        for (const it of itensCombinacao) {

          if (this.itens && this.itens.some(p => p.produto === it.produto)) {
            const item = this.itens.find(p => p.produto === it.produto);
            it.pUnitario = it.produtoTela.precoVenda;
            item.qt = it.qt;
            item.qtSugerida = it.qtSugerida;
            item.situacaoProduto = it.situacaoProduto;
            await this.atualizaValorProduto(item);
          } else {
            it.pUnitario = it.produtoTela.precoVenda;
            it.qtAnterior = it.qt;
            this.itens.push(it);
            this.ordenaProdutos();
            await this.atualizaValorProduto(it);
          }
        }

        if (this.orcamento.flag === 4 && this.itens.some(p => p.produtoTela.familia === 2 || p.produtoTela.familia === 3)) {
          this.itens.filter(p => p.produtoTela.familia === 2 || p.produtoTela.familia === 3).forEach(async it => await this.atualizaValorProduto(it));
        }
      }
    }
    else {
      this.carregandoService.mostra('buscaItensEstrutura');

      const copiaFileiras: Fileira[] = [];

      const cabos = this.itens.some(p => p.produtoTela.familia === 5) ? this.itens.filter(p => p.produtoTela.familia === 5) : [];

      const possuiMicroInversor = this.itens.some(p => p.produtoTela.familia === 3 && p.produtoTela.tipoInv === 1 && p.qt > 0);
      this.fileiras.forEach(p => {
        p.microInversor = p.tipoInversor === 1 || possuiMicroInversor;
        p.qtdTotalModulosTodosLayouts = qtdPaineisLista === 0 ? this.quantidadeDePaineis : qtdPaineisLista;

        const copia = (Object.assign({}, p));
        copia.logo$ = '';
        copiaFileiras.push(copia);

      });

      try {

        const itensEstrutura: any = await this.pedidoService.buscarItensEstrutura(copiaFileiras, cabos).toPromise();

        if (itensEstrutura.some(p => p.situacaoProduto === 'B')) {
          this.produtoEstruturaBloqueado = true;
          swal({
            title: 'ATENÇÃO!!!',
            html: 'Existem produtos da estrutura que estão bloqueados!!!',
            buttonsStyling: false,
            confirmButtonClass: 'btn btn-warning',
            type: 'warning'
          }).catch(swal.noop);
        } else {

          if (this.itens && this.itens.some(p => p.produtoTela.produtoEstrutura && !itensEstrutura.some(pi => pi.produto === p.produto))) {
            for (const item of this.itens.filter(p => p.produtoTela.produtoEstrutura && !itensEstrutura.some(pi => pi.produto === p.produto))) {
              await this.excluirProduto(item, true);
            }
          }
          if (excluirItens && this.itens && this.itens.some(p => !p.produtoTela.produtoEstrutura)) {
            for (const item of this.itens.filter(p => !p.produtoTela.produtoEstrutura)) {
              await this.excluirProduto(item, true);
            }
          }

          //mantém o módulo quando vem da calculadora
          if (this.calculadora && !this.itens.some(p => p.produto === this.orcamento.painelProduto.idProduto)) {
            const novoItem = new ItemPedido();
            novoItem.produto = this.orcamento.painelProduto.idProduto;
            novoItem.qt = this.quantidadeDePaineis;
            novoItem.qtSugerida = this.quantidadeDePaineis;
            novoItem.pUnitario = this.orcamento.painelProduto.precoVenda;
            novoItem.vTotal = novoItem.qt * novoItem.pUnitario;
            novoItem.situacaoProduto = this.orcamento.painelProduto.situacao;
            novoItem.qtAnterior = novoItem.qt;
            novoItem.produtoTela = this.orcamento.painelProduto;
            novoItem.det1 = this.orcamento.painelProduto.descricaoAtual;
            novoItem.pVendaOriginal = novoItem.pUnitario;
            this.itens.push(novoItem);
          }

          for (const it of itensEstrutura) {

            if (this.itens && this.itens.some(p => p.produto === it.produto)) {
              const item = this.itens.find(p => p.produto === it.produto);
              it.pUnitario = it.produtoTela.precoVenda;
              item.qt = it.qt;
              item.qtSugerida = it.qtSugerida;
              item.situacaoProduto = it.situacaoProduto;
              await this.atualizaValorProduto(item);
            } else {

              it.qtAnterior = it.qt;
              it.pUnitario = it.produtoTela.precoVenda;
              this.itens.push(it);
              this.ordenaProdutos();
              await this.atualizaValorProduto(it);
            }
          }

          if (this.orcamento.flag === 4 && this.itens.some(p => p.produtoTela.familia === 2 || p.produtoTela.familia === 3)) {
            this.itens.filter(p => p.produtoTela.familia === 2 || p.produtoTela.familia === 3).forEach(async it => await this.atualizaValorProduto(it));
          }
        }

      } catch (erro) {
        this.notificacaoService.erro(erro);
      } finally {
        this.carregandoService.esconde('buscaItensEstrutura');
      }

      // this.pedidoService.buscarItensEstrutura(this.fileiras, cabos).subscribe(async (itensEstrutura: ItemPedido[]) => {
      //   this.carregandoService.esconde('buscaItensEstrutura');

      //   if (itensEstrutura.some(p => p.situacaoProduto === 'B')) {
      //     this.produtoEstruturaBloqueado = true;
      //     swal({
      //       title: 'ATENÇÃO!!!',
      //       html: 'Existem produtos da estrutura que estão bloqueados!!!',
      //       buttonsStyling: false,
      //       confirmButtonClass: 'btn btn-warning',
      //       type: 'warning'
      //     }).catch(swal.noop);
      //   } else {

      //     if (this.itens && this.itens.some(p => p.produtoTela.produtoEstrutura && !itensEstrutura.some(pi => pi.produto === p.produto))) {
      //       for (const item of this.itens.filter(p => p.produtoTela.produtoEstrutura && !itensEstrutura.some(pi => pi.produto === p.produto))) {
      //         await this.excluirProduto(item, true);
      //       }
      //     }
      //     if (excluirItens && this.itens && this.itens.some(p => !p.produtoTela.produtoEstrutura)) {
      //       for (const item of this.itens.filter(p => !p.produtoTela.produtoEstrutura)) {
      //         await this.excluirProduto(item, true);
      //       }
      //     }

      //     //mantém o módulo quando vem da calculadora
      //     if (this.calculadora && !this.itens.some(p => p.produto === this.orcamento.painelProduto.idProduto)) {
      //       const novoItem = new ItemPedido();
      //       novoItem.produto = this.orcamento.painelProduto.idProduto;
      //       novoItem.qt = this.quantidadeDePaineis;
      //       novoItem.qtSugerida = this.quantidadeDePaineis;
      //       novoItem.pUnitario = this.orcamento.painelProduto.precoVenda;
      //       novoItem.vTotal = novoItem.qt * novoItem.pUnitario;
      //       novoItem.situacaoProduto = this.orcamento.painelProduto.situacao;
      //       novoItem.qtAnterior = novoItem.qt;
      //       novoItem.produtoTela = this.orcamento.painelProduto;
      //       novoItem.det1 = this.orcamento.painelProduto.descricaoAtual;
      //       this.itens.push(novoItem);
      //     }

      //     for (const it of itensEstrutura) {

      //       if (this.itens && this.itens.some(p => p.produto === it.produto)) {
      //         const item = this.itens.find(p => p.produto === it.produto);
      //         item.qt = it.qt;
      //         item.qtSugerida = it.qtSugerida;
      //         item.situacaoProduto = it.situacaoProduto;
      //         await this.atualizaValorProduto(item);
      //       } else {

      //         it.qtAnterior = it.qt;
      //         this.itens.push(it);
      //         this.ordenaProdutos();
      //         await this.atualizaValorProduto(it);
      //       }
      //     }

      //     if (this.orcamento.flag === 4 && this.itens.some(p => p.produtoTela.familia === 2)) {
      //       this.itens.filter(p => p.produtoTela.familia === 2).forEach(async it => await this.atualizaValorProduto(it));
      //     }
      //   }

      // }, (erro) => {
      //   this.carregandoService.esconde('buscaItensEstrutura');
      //   this.notificacaoService.erro(erro);
      // });
    }
  }

  inserirLogAcessoTela() {
    this.carregandoService.mostra('inserirLogAcessoTela');
    this.logAcessoService.InserirAcessoTela().subscribe(resp => {
      this.carregandoService.esconde('inserirLogAcessoTela');
    }, (erro) => {
      this.carregandoService.esconde('inserirLogAcessoTela');
      this.notificacaoService.erro(erro);
    });
  }



  buscarCliente() {
    this.carregandoService.mostra('buscaClientes');
    this.clienteService.consultarPorIdCliente(this.orcamento.cliente, true).subscribe(cli => {

      const idCD = (this.cliente !== null && this.cliente !== null) ? this.cliente.idCD : null;

      this.cliente = cli;
      this.cliente.idCD = idCD;

      if (this.integrador && (!this.idOrcamento || this.duplicando)) {
        this.vendedorSelecionado = this.vendedor ? this.vendedor.idFuncion : this.cliente.vendedor;

      }

      if (this.cliente.descontoMaximoGI > this.descontoMaximo) {
        this.descontoMaximo = this.cliente.descontoMaximoGI;
      }


      this.carregandoService.esconde('buscaClientes');
    }, (erro) => {
      this.carregandoService.esconde('buscaClientes');
      this.notificacaoService.erro(erro);
    });
  }

  inserirFileira() {
    const nFileira: Fileira = new Fileira();
    nFileira.uf = this.ufInstalacao;
    Object.assign(nFileira, this.novaFileira);

    this.fileiras.push(nFileira);
    this.novaFileira = new Fileira();
    this.novaFileira.uf = this.ufInstalacao;
  }

  async excluirFileira(fileira: Fileira) {
    this.fileiras.splice(this.fileiras.indexOf(fileira), 1);
    await this.buscarItensEstrutura(null, false);
  }

  // atualiza os totais
  async atualizaValores() {

    let valortotal = 0;
    let valorTotalItensComDesconto = 0;

    if (!this.orcamento.frete || this.orcamento.frete === null) {
      this.orcamento.frete = 0;
    }

    // if (!this.orcamento.valorServico || this.orcamento.valorServico === null) {
    //   this.orcamento.valorServico = 0;
    // }

    this.itens.forEach(p => {
      valortotal += Number((Number(p.pUnitario) * Number(p.qt)).toFixed(2));
      valorTotalItensComDesconto += p.vTotal;
    });

    this.orcamento.valorTotal = Number(valortotal.toFixed(2));
    this.orcamento.valorTotalItensComDesconto = valorTotalItensComDesconto;

    await this.calcularValorFinal();

    if (this.orcamento.valorDa) {
      this.orcamento.valorFinal = Number((this.orcamento.valorTotal - this.orcamento.valorDa).toFixed(2));

      if (this.orcamento.da === 0) {
        this.orcamento.valorFinal = Number((this.orcamento.valorTotal - this.orcamento.valorDa).toFixed(2));
      } else {
        this.orcamento.valorFinal = Number((this.orcamento.valorTotal + this.orcamento.valorDa).toFixed(2));
      }

    } else {
      this.orcamento.valorFinal = this.orcamento.valorTotal;
    }

    this.valorFinalComissao = this.orcamento.valorFinal;

    // if (this.orcamento.flag === 4) {
    //   this.orcamento.frete = Number(((this.orcamento.valorFinal * this.txFrete) / 100).toFixed(2));
    // }

    // this.orcamento.valorFinal = Number((this.orcamento.valorFinal + Number(this.orcamento.frete) + Number(this.orcamento.valorServico)).toFixed(2));
    this.orcamento.valorFinal = Number((this.orcamento.valorFinal + Number(this.orcamento.frete)).toFixed(2));
    this.calcularPesoBruto();

    this.area = 0;

    if (this.itens.some(i => i.produtoTela.familia === 2)) {
      this.itens.map(i => {
        if (i.produtoTela.familia === 2) {
          this.area += (i.produtoTela.tamanho * i.qt);
        }
      });
    }
  }

  // valida a tela de acordo com a tab atual
  valida() {

    switch (this.tabIndex) {
      case 0:
        return !this.produtoEstruturaBloqueado;
    }
  }

  ngOnDestroy(): void {

  }

  calcularQtdPaineis() {
    this.qtdPainelSugestao = 0;


    if (this.fileiras && this.fileiras.length > 0) {
      this.fileiras.forEach(p => {
        this.qtdPainelSugestao += (p.numPaineis * p.fileiras);
      });

      if (this.quantidadeDePaineis > 0 && this.qtdPainelSugestao !== this.quantidadeDePaineis) {
        this.msgQtdPaineis = true;
      } else {
        this.msgQtdPaineis = false;
      }
    } else {
      this.msgQtdPaineis = false;
    }

    this.verificaPaineisEstrutura();
  }

  validarSalvar() {
    return this.itens !== null && this.itens !== undefined && ((this.regraValidacaoKitPersonalizado === 0 &&
      this.itens.some(p => p.produtoTela.familia === 2 && p.qt > 0) &&
      this.itens.some(p => p.produtoTela.familia === 3 && p.qt > 0)) ||
      (this.regraValidacaoKitPersonalizado === 1 &&
        (this.itens.some(p => p.produtoTela.familia === 2 && p.qt > 0) ||
          this.itens.some(p => p.produtoTela.familia === 3 && p.qt > 0))));
  }

  salvarGenerico(tipo) {
    if (this.pUsarAcrescimo && this.cliente.daGI === 1) {
      this.orcamento.da = 1;
    }

    const percentual = this.orcamento.descontoIndividual ?
      ((100 * (this.orcamento.valorTotal - this.orcamento.valorTotalItensComDesconto)) / this.orcamento.valorTotal) :
      (this.pUsarAcrescimo && this.cliente.daGI === 1 ? this.cliente.acrescimoGI : undefined);
    this.orcamento.valorDa = this.orcamento.descontoIndividual ?
      Number((this.orcamento.valorTotal - this.orcamento.valorTotalItensComDesconto).toFixed(2)) :
      (this.pUsarAcrescimo && this.cliente.daGI === 1 ? Number((Number(this.orcamento.valorTotal) * this.cliente.acrescimoGI / 100).toFixed(2)) : this.orcamento.valorDa);

    let idFornecedor = null;

    if (this.pCentroDistribuicao) {
      idFornecedor = this.cliente.idCD;
    }

    if (this.multiFornecedores) {
      idFornecedor = this.orcamento.painelProduto.idFornecedor;
    }

    let qtModulos = 0;

    if (this.premissasSistema.usaDescargaCif) {
      qtModulos = this.itens.reduce((total, it) => {
        if (it.produtoTela.familia === 2) {
          return total + it.qt;
        }
        if (it.produtoTela.familia === 7) {
          return total + it.produtoTela.composicao.reduce((compTotal, comp) => {
            return comp.produtoMP.familia === 2 ? compTotal + (comp.qt * it.qt) : compTotal;
          }, 0);
        }
        return total;
      }, 0);
    }

    const largura = Number($('body').width());
    const dialogRef = this.dialog.open(DigitaCampoModalComponent, {
      width: largura > 1030 ? '1000px' : (($('body').width()).toString() + 'px'),
      // passa os produtos já selecionados
      data: {
        origem: 0,
        tipo: tipo,
        selecionarIntegrador: !this.integrador,
        informarNome: true,
        valorProdutos: this.orcamento.valorTotal,
        ibge: this.cliente ? this.cliente.ibge : '',
        calculadora: this.calculadora,
        uf: this.estadoSelecionado,
        cidade: this.cidadeSelecionado,
        idDescarga: this.orcamento.idDescarga,
        cliente: this.cliente,
        nome: this.nome,
        vendedor: this.vendedor ? this.vendedor : (!this.integrador ? { idFuncion: this.usuarioLogado.id, nome: this.usuarioLogado.nome } : null),
        limDesc: this.limDesc,
        descAcresPrecificacaoUF: this.descAcresPrecificacaoUF,
        da: this.orcamento.descontoIndividual ? 0 : this.orcamento.da,
        valorDa: this.orcamento.valorDa,
        percentual: percentual,
        descontoIndividual: this.orcamento.descontoIndividual,
        potencia: this.potSistema,
        idCD: this.pCentroDistribuicao
          ? this.cliente.idCD
          : (this.multiFornecedores && this.orcamento.painelProduto !== null && this.orcamento.painelProduto !== undefined ? this.orcamento.painelProduto.idFornecedor : undefined),
        valorTotalFixo: this.orcamento.valorTotalFixo,
        itens: JSON.parse(JSON.stringify(this.itens)),
        idFornecedor: idFornecedor,
        qtModulos: qtModulos
      },
      panelClass: 'modal-card',
      // maxHeight: '95vh',
      autoFocus: false
    });

    dialogRef.afterClosed().subscribe(async (result: any) => {
      if (result) {
        this.orcamento.comprador = result.nome;
        this.pedidoService.setFormaPagPedido(this.orcamento, result.formaPagamento);
        this.pedidoService.setCondPagPedido(this.orcamento, result.condicaoPagamento);
        if (tipo !== 0) {

          this.orcamento.vendaDireta = result.vendaDireta;
          this.clienteFaturamento = result.clienteFaturamento;
        }
        this.orcamento.txLocalizacao = result.txLocalizacao;
        this.orcamento.tipoLocalizacao = result.localizacao;
        this.orcamento.da = result.da;
        this.orcamento.valorDa = Number(result.valorDa);
        this.orcamento.percentual = Number(result.percentual);
        this.orcamento.tipoFrete = Number(result.tipoFrete);
        this.orcamento.frete = Number(result.valorFrete);
        this.orcamento.entrega = Number(result.entrega);
        this.orcamento.taxaDA = Number(result.taxaDA);
        this.enderecoDeEntrega = result.enderecoEntrega;
        this.enderecoDeEntrega.ibge = Number(this.enderecoDeEntrega.ibge);
        this.orcamento.origemGI = 0;
        this.orcamento.valorServico = Number(result.valorServico);
        this.orcamento.valorServicoLiquido = Number(result.valorLiquido);
        this.orcamento.transportadora = result.idTransportadora;
        this.orcamento.idDescarga = result.idDescarga === null || result.idDescarga === undefined ? null : Number(result.idDescarga);

        this.orcamento.obs2 = result.enderecoEntregaCompleto;

        this.orcamento.formasPagamento = result.formasPagamento;

        this.itens = JSON.parse(JSON.stringify(result.itens));
        this.descAcresPrecificacaoUF = result.descAcresPrecificacaoUF;
        this.orcamento.valorTotal = result.valorProdutos;
        this.orcamento.voucher = result.voucher;
        this.orcamento.valorVoucher = result.valorVoucher;
        this.orcamento.dadosVoucher = result.dadosVoucher;

        this.orcamento.freteManual = result.freteManual;

        this.orcamento.seguros = result.seguros;
        this.orcamento.servicoEntrega = result.servicoEntrega;
        this.orcamento.valorServicoEntrega = result.valorServicoEntrega;
        this.orcamento.servicoEntregaManual = result.servicoEntregaManual;

        this.orcamento.valorProjeto = result.valorProjeto;
        this.orcamento.valorProjetoLiquido = result.valorProjetoLiquido;
        this.orcamento.tipoCIF = result.tipoCIF;

        this.orcamento.valorTotalFixo = result.valorTotalFixo;

        this.orcamento.idFrete = result.idFrete;

        if (!this.integrador) {
          this.orcamento.cliente = result.cliente.id;
        }

        this.orcamento.multiFormaPagamento = result.usandoMultiFormasPagamento;

        this.orcamento.impostos = result.impostos;
        this.orcamento.valorImpostos = result.valorImpostos;
        this.orcamento.impostosPendente = result.impostoPendente;

        this.comprovante = result.comprovante;
        this.confirmar = result.confirmar;

        this.respostas = result.respostas;

        await this.salvarPedido(tipo);
      }
    });
  }

  async lembreteVertys() {
    if (this.exibirLembreteVertys) {
      return new Promise((resolve, reject) => {
        swal({
          title: 'ATENÇÃO!!!',
          html: `Caro Integrador,
                 <br>
                 Se necessário, lembre-se de adicionar mais Mid Clamp (Grampo Intermediário), End Clamp (Grampo Final), String Box (Protetor de Rede) ou demais acessórios ao seu Kit Gerador Solar.`,
          type: 'warning',
          showCancelButton: true,
          confirmButtonClass: 'btn btn-info',
          cancelButtonClass: 'btn btn-success',
          confirmButtonText: 'Revisar',
          cancelButtonText: 'Avançar',
          buttonsStyling: false
        }).then((result) => {
          if (result.value) {
            resolve(true);
          } else {
            resolve(false);
          }
        });
      });
    } else {
      return Promise.resolve(false);
    }
  }


  async salvarOrcamento(tipo) {
    if (await this.lembreteVertys()) {
      return;
    }

    this.orcamento.foraDaRegra = false;

    if (this.validarKitCustomizado && !(await this.validarCombinacao())) {
      return;
    }

    this.salvarGenerico(tipo);
  }

  async validarCombinacao() {

    try {
      this.carregandoService.mostra('validarCombinacao');
      await this.pedidoService.validarCombinacao(this.itens).toPromise();
      this.carregandoService.esconde('validarCombinacao');
      return true;
    } catch (erro) {
      this.carregandoService.esconde('validarCombinacao');

      this.notificacaoService.erro(erro);

      if (!this.integrador && !this.premissasUsuario.travarValidarKitCustomizado) {
        const result = await swal({
          title: 'Atenção!!',
          text: 'Combinação está fora do padrão. Deseja continuar mesmo assim?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonClass: 'btn btn-info',
          cancelButtonClass: 'btn btn-danger',
          confirmButtonText: 'Sim',
          cancelButtonText: 'Não',
          buttonsStyling: false
        });

        if (result.value) {
          this.orcamento.foraDaRegra = true;
        }

        return result.value;
      } else {
        return false;
      }
    }
  }



  async salvarPedido(tipo) {
    this.carregandoService.mostra('salvaPedido');

    const vendedorSelecionado = this.vendedor ? this.vendedor.idFuncion : this.usuarioLogado.id;
    this.orcamento.vendedor = this.integrador ? this.cliente.vendedor : vendedorSelecionado;

    this.orcamento.indicacao = 0;
    // this.orcamento.formaPag = this.formaDePagamentoSelecionado;
    // this.orcamento.planoPag = this.condicaoDePagamentoSelecionado;
    this.orcamento.nItens = this.itens.length;
    // this.orcamento.da = 0;
    this.orcamento.troco = 0;
    this.orcamento.nParcelas = 1;
    this.orcamento.gTotal = 0;
    this.orcamento.nCartao = '1';
    this.orcamento.bc = 0;
    this.orcamento.ext = 0;
    this.orcamento.nECF = '0';
    this.orcamento.turno = 0;
    this.orcamento.nTurno = 0;
    this.orcamento.status = 0;
    // this.orcamento.np = 0;
    // this.orcamento.percentual = 0;
    this.orcamento.nPdv = 98;
    this.orcamento.nLoja = 1;

    //this.orcamento.valorDa = 0
    //this.orcamento.percentual = 0;
    //this.orcamento.frete = 0;
    // this.orcamento.valorServico = 0;
    this.orcamento.funcDesco = 0;
    this.orcamento.data = new Date();
    this.orcamento.cliente = this.cliente.id;

    this.orcamento.ibgeInstalacao = this.ibgeInstalacao;

    if (this.multiFornecedores) {
      this.orcamento.idFornecedor = this.orcamento.painelProduto.idFornecedor;
    }

    if (this.pCentroDistribuicao) {
      this.orcamento.idFornecedor = this.cliente.idCD;
    }

    this.itens.forEach(it => {
      it.nItem = this.itens.indexOf(it) + 1;
      it.cc = it.produtoTela.cc;
      it.comissao = 0;
      it.da = 0; // se tiver desconto é 0

      it.frete = 0;
      it.pCusto = it.produtoTela.precoCusto;

      if (!this.orcamento.descontoIndividual) {
        it.valorDa = 0;
        it.percentual = 0;
      }


      it.idCupom = this.idOrcamento ? this.idOrcamento : it.idCupom;
    });
    this.salvar(tipo);
  }


  salvar(tipo) {

    this.itens.forEach(p => { p.pVendaOriginal = p.produtoTela.precoVenda; });

    if (tipo === 1 && this.confirmar) {
      this.pedidoService.confirmarOrcamento(this.orcamento, this.itens, this.fileiras, this.orcamento.vendaDireta ? this.clienteFaturamento : null, false, tipo === 0 ? true : false, false, this.enderecoDeEntrega, this.comprovante, this.respostas).subscribe((resp: any) => {
        this.idOrcamento = resp.idCupom;
        // this.notificacaoService.sucesso(this.texto + ' Salvo com sucesso!!!');
        this.carregandoService.esconde('salvaPedido');
        //
        this.notificacaoService.sucesso('Pedido Confirmado com sucesso!!!');
        this.router.navigate(['/pedidos']);
      }, (erro) => {
        this.carregandoService.esconde('salvaPedido');
        this.notificacaoService.erro(erro);

        this.definirItemSemLote(erro);

      });
    } else {
      this.pedidoService.salvar(this.orcamento, this.itens, this.fileiras, this.orcamento.vendaDireta ? this.clienteFaturamento : null, false, tipo === 0 ? true : false, false, this.enderecoDeEntrega, this.respostas).subscribe((resp: any) => {
        this.idOrcamento = resp.idCupom;
        this.notificacaoService.sucesso((tipo === 0 ? 'Orçamento' : 'Pedido') + ' Salvo com sucesso!!!');
        this.carregandoService.esconde('salvaPedido');
        this.router.navigate([tipo === 0 ? '/orcamentos' : '/pedidos']);
      }, (erro) => {
        this.carregandoService.esconde('salvaPedido');
        this.notificacaoService.erro(erro);
        this.definirItemSemLote(erro);
      });
    }


  }

  buscarPremissaVendaProgramada() {
    this.carregandoService.mostra('buscarPremissaVendaProgramada');
    this.premissasService.consultarVendaProgramada().subscribe(f => {
      if (f.valor) {
        this.vendaProgramada = true;
      }

      this.carregandoService.esconde('buscarPremissaVendaProgramada');
    }, (erro) => {
      this.carregandoService.esconde('buscarPremissaVendaProgramada');
      this.notificacaoService.erro(erro);
    });
  }



  definirItemSemLote(erro) {

    this.itemSemLote = false;

    if (this.vendaProgramada && erro.error && erro.error.itemSemLote) {

      this.itemSemLote = true;

      this.itens.forEach(p => {
        p.produtoTela.semLote = false;

        if (p.produto === erro.error.itemSemLote) {
          p.produtoTela.semLote = true;
        } else if (p.produtoTela.composicao) {
          p.produtoTela.composicao.forEach(c => {
            c.produtoMP.semLote = false;
            if (c.proMP === erro.error.itemSemLote) {
              p.produtoTela.semLote = true;
              c.produtoMP.semLote = true;
            }
          });
        }
      });
    }
  }

  verificaValidacaoKit() {

    this.carregandoService.mostra('verificaValidacaoKit');
    this.premissasService.validarKitCustomizado().subscribe(data => {
      this.validarKitCustomizado = data.validar;
      this.carregandoService.esconde('verificaValidacaoKit');
    }, (erro) => {
      this.carregandoService.esconde('verificaValidacaoKit');
      this.notificacaoService.erro(erro);
    });

  }

  defineTabAlvo(alvo) {
    this.tabAlvo = alvo;
  }

  novaEstrutura() {
    let fileira = new Fileira();
    fileira.uf = this.ufInstalacao;
    fileira.larguraPainel = this.orcamento.painelProduto.largura;
    fileira.comprimentoPainel = this.orcamento.painelProduto.comprimento;
    fileira.alturaPainel = this.orcamento.painelProduto.altura;
    fileira.referenciaPainel = this.orcamento.painelProduto.referencia;

    if (this.pCentroDistribuicao) {
      fileira.idFornecedorPainel = this.cliente.idCD;
    }

    if (this.multiFornecedores) {
      fileira.idFornecedorPainel = this.orcamento.painelProduto.idFornecedor;
    }

    let totalPaineis = 0;
    if (this.calculadora) {
      this.fileiras.map((f) => {
        totalPaineis += f.fileiras * f.numPaineis;
      });
    }

    const largura = Number(($('body').width()));
    const dialogRef = this.dialog.open(CadastrarEstruturaComponent, {
      width: largura > 1500 ? '1400px' : (($('body').width()).toString() + 'px'),
      // passa os produtos já selecionados
      data: {
        fileira: fileira,
        fornecedoresUtilizados: this.fileiras.map(f => f.fornecedor),
        quantidadeDePaineis: this.quantidadeDePaineis,
        totalPaineis: totalPaineis,
        calculadora: this.calculadora
      },
      panelClass: 'modal-card',
      maxWidth: '98vw',
      maxHeight: '95vh'
    });

    // quando fecha o modal
    dialogRef.afterClosed().subscribe((result: Fileira) => {
      if (result) {
        result.larguraPainel = this.orcamento.painelProduto.largura;
        result.comprimentoPainel = this.orcamento.painelProduto.comprimento;
        result.alturaPainel = this.orcamento.painelProduto.altura;
        result.referenciaPainel = this.orcamento.painelProduto.referencia;
        result.fileiras = Number(result.fileiras);
        result.numPaineis = Number(result.numPaineis);
        result.orientacao = result.orientacao;
        result.telhado = Number(result.telhado);
        this.carregandoService.mostra('atualizarFileiras');
        this.pedidoService.atualizarFileira(result).subscribe(async resp => {
          this.fileiras.push(resp);
          await this.buscarItensEstrutura(null, false);
          this.verificaPaineisEstrutura();
          this.carregandoService.esconde('atualizarFileiras');
        }, (erro) => {
          this.carregandoService.esconde('atualizarFileiras');
          this.notificacaoService.erro(erro);
        });
      }
    });
  }

  verificaPaineisEstrutura() {
    const quantidadeDePaineisFileiras = this.fileiras.reduce((acc, curr) => (acc + curr.numPaineis * curr.fileiras), 0);

    const quantidadePaineisListaProdutos = this.itens.filter(p => p.produtoTela.familia === 2).reduce((acc, curr) => (acc + curr.qt), 0);

    this.podeRecalcularEstrutura = quantidadePaineisListaProdutos !== quantidadeDePaineisFileiras && quantidadePaineisListaProdutos > 0;

    if (this.podeRecalcularEstrutura) {
      this.novaQuantidadePaineis = quantidadePaineisListaProdutos - quantidadeDePaineisFileiras;
    } else {
      this.novaQuantidadePaineis = undefined;
    }
  }

  recalcularEstrutura() {
    if (!this.podeRecalcularEstrutura || !this.fileiras.length) return;

    const ultimaFileira = this.fileiras[this.fileiras.length - 1];

    if (this.fileiras && this.fileiras.length > 1) {
      if (this.novaQuantidadePaineis > 0) {
        this.editarEstrutura(
          this.fileiras[0],
          Math.round(this.novaQuantidadePaineis / this.fileiras[0].fileiras)
        );
      } else {
        if ((((ultimaFileira.numPaineis * ultimaFileira.fileiras) + this.novaQuantidadePaineis) / ultimaFileira.fileiras) > 1) {
          this.editarEstrutura(
            ultimaFileira,
            Math.round(this.novaQuantidadePaineis / ultimaFileira.fileiras)
          );
        } else {
          swal({
            title: 'Atenção!!',
            text: 'Não foi possível recalcular automaticamente, favor editar manualmente os layouts.',
            type: 'warning',
            showCancelButton: false,
            confirmButtonClass: 'btn btn-info',
            confirmButtonText: 'Ok',
            buttonsStyling: false
          }).then(() => {
            this.podeRecalcularEstrutura = false;
          });
        }
      }
    } else if (this.fileiras && this.fileiras.length === 1) {
      if (this.fileiras[0].fileiras === 1) {
        this.editarEstrutura(
          this.fileiras[0],
          Math.round(this.novaQuantidadePaineis / this.fileiras[0].fileiras)
        );
      } else {
        if (this.novaQuantidadePaineis > 0) {
          this.editarEstrutura(
            this.fileiras[0],
            Math.round(this.novaQuantidadePaineis / this.fileiras[0].fileiras)
          );
        } else {
          if (Math.round((this.fileiras[0].numPaineis - this.novaQuantidadePaineis) / this.fileiras[0].fileiras) > 0) {
            this.editarEstrutura(
              this.fileiras[0],
              Math.round(this.novaQuantidadePaineis / this.fileiras[0].fileiras)
            );
          } else {
            swal({
              title: 'Atenção!!',
              text: 'Não foi possível recalcular automaticamente, favor editar manualmente os layouts.',
              type: 'warning',
              showCancelButton: false,
              confirmButtonClass: 'btn btn-info',
              confirmButtonText: 'Ok',
              buttonsStyling: false
            }).then(() => {
              this.podeRecalcularEstrutura = false;
            });
          }
        }
      }
    }
  }

  editarEstrutura(fileira: Fileira, novaQuantidadePaineis?: number) {

    const qtdPaineisLista = this.itens.filter(p => p.produtoTela.familia === 2).reduce((acc, curr) => (acc + curr.qt), 0);

    fileira.qtdTotalModulosTodosLayouts = qtdPaineisLista === 0 ? this.quantidadeDePaineis : qtdPaineisLista;
    fileira.larguraPainel = this.orcamento.painelProduto.largura;
    fileira.comprimentoPainel = this.orcamento.painelProduto.comprimento;
    fileira.alturaPainel = this.orcamento.painelProduto.altura;
    fileira.referenciaPainel = this.orcamento.painelProduto.referencia;
    const largura = Number(($('body').width()));
    const dialogRef = this.dialog.open(CadastrarEstruturaComponent, {
      width: largura > 1500 ? '1400px' : (($('body').width()).toString() + 'px'),
      // passa os produtos já selecionados
      data: {
        fileira: Object.assign({}, fileira),
        fornecedoresUtilizados: this.fileiras.length === 1 ? [] : this.fileiras.map(f => f.fornecedor),
        novaQuantidadePaineis
      },
      panelClass: 'modal-card',
      maxWidth: '98vw',
      maxHeight: '95vh'
    });


    // quando fecha o modal
    dialogRef.afterClosed().subscribe((result: Fileira) => {
      if (result) {

        const recalcular = fileira.fileiras !== Number(result.fileiras)
          || fileira.numPaineis !== Number(result.numPaineis)
          || fileira.orientacao !== result.orientacao
          || fileira.telhado !== Number(result.telhado)
          || fileira.fornecedor !== result.fornecedor
          || fileira.idFornecedorEstrutura !== result.idFornecedorEstrutura;

        fileira.fileiras = Number(result.fileiras);
        fileira.numPaineis = Number(result.numPaineis);
        fileira.opcaoOrientacao = result.opcaoOrientacao;
        fileira.opcaoTelhado = result.opcaoTelhado;
        fileira.orientacao = result.orientacao;
        fileira.telhado = Number(result.telhado);
        fileira.fornecedor = result.fornecedor;
        fileira.idFornecedorEstrutura = result.idFornecedorEstrutura;
        fileira.microInversor = fileira.tipoInversor === 1 || this.itens.some(p => p.produtoTela.familia === 3 && p.produtoTela.tipoInv === 1 && p.qt > 0);

        this.carregandoService.mostra('atualizarFileira');

        result.qtdTotalModulosTodosLayouts = qtdPaineisLista === 0 ? this.quantidadeDePaineis : qtdPaineisLista;

        this.pedidoService.atualizarFileira(result).subscribe(async resp => {
          fileira.valorTotal = resp.valorTotal;
          fileira.itens = resp.itens;
          fileira.telhadoDescricao = resp.telhadoDescricao;
          fileira.fornecedorDescricao = resp.fornecedorDescricao;
          if (recalcular) {
            await this.buscarItensEstrutura(null, false);
          }
          // this.verificaPaineisEstrutura();

          this.podeRecalcularEstrutura = false;

          this.carregandoService.esconde('atualizarFileira');
        }, (erro) => {
          this.carregandoService.esconde('atualizarFileira');
          this.notificacaoService.erro(erro);
        });

      }
    });
  }

  detalhesDoProduto(produto: Produto) {
    const largura = Number(($('body').width()));
    const dialogRef = this.dialog.open(DetalheProdutoModalComponent, {
      width: largura > 1100 ? '1000px' : (($('body').width()).toString() + 'px'),
      // passa os produtos já selecionados
      data: {
        produto: produto
      },
      panelClass: 'modal-card',
      maxHeight: '90vh'
    });
  }

  adicionarItensSemLayout() {
    $('#botaoProximo').click();

    this.pesquisarProdutos();
  }

  async atualizaDesconto(tipo, valida) {


    if (this.orcamento.flag === 4) {
      if (tipo === 0) {
        if (!this.orcamento.percentual) {
          this.orcamento.valorDa = 0;
          this.orcamento.percentual = 0;
        } else {


          this.orcamento.valorDa = Number(((Number(this.orcamento.valorTotal) * this.orcamento.percentual) / 100).toFixed(2));

        }
      } else {
        if (!this.orcamento.valorDa) {
          this.orcamento.percentual = 0;
          this.orcamento.valorDa = 0;
        } else {
          this.orcamento.percentual = ((this.orcamento.valorDa * 100) / Number(this.orcamento.valorTotal));
        }
      }

      await this.atualizaValores();
    }
  }

  detalhesDaEstrutura(itens) {
    const largura = Number(($('body').width()));
    const dialogRef = this.dialog.open(DetalheEstruturaModalComponent, {
      width: largura > 850 ? '800px' : (($('body').width()).toString() + 'px'),
      data: {
        itens: itens
      },
      panelClass: 'modal-card',
      maxHeight: '90vh'
    });
  }

  configurarLayout() {
    const largura = Number(($('body').width()));
    const dialogRef = this.dialog.open(LayoutModalComponent, {
      width: largura > 850 ? '800px' : (($('body').width()).toString() + 'px'),
      data: {
        painel: this.orcamento.painel,
        fase: this.orcamento.fase,
        tensao: this.orcamento.tensao
      },
      panelClass: 'modal-card',
      maxHeight: '90vh'
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        this.orcamento.painel = result.painelSelecionado.idProduto;
        this.orcamento.painelProduto = result.painelSelecionado;
        this.orcamento.fase = result.faseSelecionada;
        this.orcamento.tensao = result.tensaoSelecionada;
        if (!this.configurouLayout) {
          this.novaEstrutura();
        }
        this.configurouLayout = true;

        this.verificaPaineisEstrutura();
      }
    });
  }


  calcularTotalLayout() {
    let soma = 0;

    this.fileiras.forEach(fileira => {
      soma += fileira.valorTotal;
    });
    return soma;

  }

  kitsSugeridos(teste?) {
    let idFornecedorPainel;

    if (this.pCentroDistribuicao) {
      idFornecedorPainel = this.cliente.idCD;
    }

    if (this.multiFornecedores) {
      idFornecedorPainel = this.orcamento.painelProduto.idFornecedor;
    }

    const percentual = this.orcamento.descontoIndividual ?
      ((100 * (this.orcamento.valorTotal - this.orcamento.valorTotalItensComDesconto)) / this.orcamento.valorTotal) :
      (this.pUsarAcrescimo && this.cliente.daGI === 1 ? this.cliente.acrescimoGI : undefined);
    const valorDa = this.orcamento.descontoIndividual ?
      Number((this.orcamento.valorTotal - this.orcamento.valorTotalItensComDesconto).toFixed(2)) :
      (this.pUsarAcrescimo && this.cliente.daGI === 1 ? Number((Number(this.orcamento.valorTotal) * this.cliente.acrescimoGI / 100).toFixed(2)) : this.orcamento.valorDa);

    const largura = Number(($('body').width()));
    const dialogRef = this.dialog.open(KitsSugeridosModalComponent, {
      width: largura > 1050 ? '1000px' : (($('body').width()).toString() + 'px'),
      data: {
        ibge: this.cidadeSelecionado,
        descontoIndividual: this.orcamento.descontoIndividual,
        percentual: percentual,
        valorDa: valorDa,
        buscarValorFinal: this.calcValorFinalSugestao,
        idCliente: !this.integrador ? this.cliente.id : this.usuarioLogado.id,
        idPainel: this.orcamento.painel,
        fase: this.orcamento.fase,
        tensao: this.orcamento.tensao,
        qtdPainel: this.quantidadeDePaineis,
        fileiras: this.fileiras,
        idMarca: this.idMarca,
        idFornecedorPainel: idFornecedorPainel,
        potSistema: this.potSistema,
        buscarMicroinversores: this.tipoInv === 1 || (this.fileiras !== undefined && this.fileiras !== null && this.fileiras.length > 0 && this.fileiras[0].tipoInversor === 1),
        tipoInv: this.tipoInv,
        msgAlterarCD: this.integrador && this.intPodeAlterarCD && this.pCentroDistribuicao && this.cliente && this.mostrarMsgTrocaCD.valor && this.mostrarMsgTrocaCD.msg ? this.mostrarMsgTrocaCD.msg : undefined,
        uf: this.ufInstalacao,
        incluirStringBox: this.incluirStringBox,
        marcaStringbox: this.marcaStringbox
      },
      panelClass: 'modal-card',
      maxHeight: '90vh'
    });
    dialogRef.afterClosed().subscribe(async (result: any) => {
      if (result) {
        this.buscarEstoque(result);
        await this.buscarItensEstrutura(result);
        $('#botaoProximo').click();
      }
    });
  }

  validaKitsSugeridos() {

    return this.painel !== null && this.painel !== undefined &&
      this.quantidadeDePaineis !== null && this.quantidadeDePaineis !== undefined &&
      this.tensao !== null && this.tensao !== undefined &&
      this.fase !== null && this.fase !== undefined;
  }

  buscarVerPrecosProdutos() {
    this.carregandoService.mostra('buscarVerPrecosProdutos');
    this.premissasService.consultarVerPrecoProdutos().subscribe(f => {
      this.mostrarValores = f.valor;
      this.carregandoService.esconde('buscarVerPrecosProdutos');
    }, (erro) => {
      this.carregandoService.esconde('buscarVerPrecosProdutos');
      this.notificacaoService.erro(erro);
    });
  }

  nomeArquivoEstrutura(fileira) {
    if (fileira.fornecedor === undefined || fileira.fornecedor === null) { return 'semestrutura'; }
    else {
      switch (fileira.fornecedor) {
        case 0:
          return 'alfix';
        case 1:
          return 'photoenergy';
        case 2:
          return 'gosolar';
        case 3:
          return 'fotus';
        case 4:
        case 10:
          return 'romagnole';
        case 5:
          return 'brassunny';
        case 6:
          return 'ssm';
        case 7:
          return 'lbsolar';
        case 8:
          return 'viener';
        case 9:
          return 'ccm';
        case 11:
          return 'bellesystem';
        case 12:
          return 'pratyc';
        case 13:
          return 'e3';
        case 14:
          return 'solargroup';
        case 15:
        case 16:
        case 17:
          return 'vertys';
        case 18:
          return 'k2';
      }
    }
  }

  calcularPesoBruto() {
    this.pesoBruto = 0;
    this.itens.forEach((element: any) => {
      this.pesoBruto += element.produtoTela.peso ? element.produtoTela.peso * element.qt : 0;
    });
  }

  buscarMostrarCodErp() {
    this.carregandoService.mostra('buscarMostrarCodErp');
    this.premissasService.consultarMostrarCodErp().subscribe(f => {
      this.mostrarCodErp = f.valor;
      this.carregandoService.esconde('buscarMostrarCodErp');
    }, (erro) => {
      this.carregandoService.esconde('buscarMostrarCodErp');
      this.notificacaoService.erro(erro);
    });
  }

  voltarCalculadora() {
    this.router.navigate(['calculadora'],
      {
        state: {
          voltouPagina: true
        }
      });
  }

  buscarMostrarBifasico() {
    this.carregandoService.mostra('buscarMostrarBifasico');
    this.premissasService.consultarMostrarBifasico().subscribe(f => {
      this.mostrarBifasico = f.valor;
      this.carregandoService.esconde('buscarMostrarBifasico');
    }, (erro) => {
      this.carregandoService.esconde('buscarMostrarBifasico');
      this.notificacaoService.erro(erro);
    });
  }


  buscarUsarCombImp() {
    this.carregandoService.mostra('consultarUsarCombImp');
    this.premissasService.consultarUsarCombImp().subscribe(f => {
      this.usarCombImp = f.valor;
      this.carregandoService.esconde('consultarUsarCombImp');
    }, (erro) => {
      this.carregandoService.esconde('consultarUsarCombImp');
      this.notificacaoService.erro(erro);
    });
  }



  buscarEstruturasPersonalizadas() {
    this.carregandoService.mostra('buscarEstruturasPersonalizadas');
    this.premissasService.consultarEstruturasPersonalizadas().subscribe(f => {
      this.estruturasPersonalizadas = f;

      this.carregandoService.esconde('buscarEstruturasPersonalizadas');
    }, (erro) => {
      this.carregandoService.esconde('buscarEstruturasPersonalizadas');
      this.notificacaoService.erro(erro);
    });
  }

  buscarDescricaoTelhado(fileira: Fileira) {
    switch (fileira.telhado) {
      case 8:
        return this.estruturasPersonalizadas.textoFibrometal;

      case 12:
        return this.estruturasPersonalizadas.textoEstruturaCalhetao;

      case 13:
        return this.estruturasPersonalizadas.textoEstruturaCarport;

      default:
        return fileira.telhadoDescricao;
    }
  }

  async buscarStringBoxConectorDoInversor(idInversor, qtdInversor, inversorSugerido) {

    if (qtdInversor === null || qtdInversor === undefined)
      qtdInversor = 0;

    let idFornecedorPainel;

    if (this.multiFornecedores) {
      idFornecedorPainel = this.orcamento.painelProduto.idFornecedor;
    }

    if (this.pCentroDistribuicao) {
      idFornecedorPainel = this.cliente.idCD;
    }

    try {
      this.carregandoService.mostra('buscarStringBoxConectorDoInversor');

      const produtos = await this.pedidoService.buscarStringBoxConectorDoInversor(idInversor, qtdInversor, this.orcamento.painel, idFornecedorPainel).toPromise();

      produtos.forEach(async p => {
        if (this.itens.some(i => i.produto === p.produto)) {
          let item = this.itens.find(i => i.produto === p.produto);
          if (qtdInversor == 0) {
            await this.excluirProduto(item, !inversorSugerido || this.removerItemSugEdicao);
          } else if (item.qt !== p.qt) {
            item.qt = p.qt;
            await this.atualizaValorProduto(item);
          }
        } else if (qtdInversor > 0) {
          this.itens.push(p);
          await this.atualizaValorProduto(p);
        }
      });

    } catch (erro) {
      this.notificacaoService.erro(erro);
    } finally {
      this.carregandoService.esconde('buscarStringBoxConectorDoInversor');
    }





  }

  exibeIrradiacao() {
    const largura = Number($('body').width());
    const dialogRef = this.dialog.open(IrradiacaoModalComponent, {
      width: largura > 1050 ? '1000px' : $('body').width().toString() + 'px',
      data: {
        meses: this.meses, cidade: this.nomeCidade, uf: this.estadoSelecionado
      },
      panelClass: 'modal-card',
      maxHeight: '90vh',
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
      }
    });
  }

  voltarParaMontarKit() {

    if (!this.pCentroDistribuicao && !this.telhadoNaCalculadora && this.comEstrutura && this.fileiras !== null && this.fileiras !== undefined) {
      this.fileiras.forEach(f => { f.logo$ = undefined; });
    }

    this.router.navigate(['montar-kit'], {
      state: { fileirasDeVolta: !this.pCentroDistribuicao && !this.telhadoNaCalculadora && this.comEstrutura ? this.fileiras : [] }
    });
  }

  mostrarEstoqueDoProduto(produto: Produto) {
    const largura = Number($('body').width());

    const dialogRef = this.dialog.open(EstoqueProdutoModalComponent, {
      width: largura > 830 ? '800px' : $('body').width().toString() + 'px',
      data: { produto, idFornecedor: this.pCentroDistribuicao ? this.cliente.idCD : null },
      panelClass: 'modal-card',
    });
  }

  async buscarPremissasSistema() {
    try {
      this.carregandoService.mostra('buscarPremissasSistema');
      this.premissasSistema = await this.premissasService.consultarPremissasSistema().toPromise();
    } catch (erro) {
      this.notificacaoService.erro(erro);
    } finally {
      this.carregandoService.esconde('buscarPremissasSistema');
    }
  }

  async buscarPrecificacoesUF() {
    try {
      this.carregandoService.mostra('buscarPrecificacoesUF');
      this.precificacoesUF = await this.precificacaoUFService.consultar().toPromise();
    } catch (erro) {
      this.notificacaoService.erro(erro);
    } finally {
      this.carregandoService.esconde('buscarPrecificacoesUF');
    }
  }

  calcularPrecificacaoUF(valor: number, precificacaoUF: PrecificacaoUF) {
    return this.precificacaoUFService.calcularPrecificacaoUF(valor, precificacaoUF);
  }

  buscarEstoque(itens: ItemPedido[]) {

    this.carregandoService.mostra('buscarEstoque');

    let idFornecedorPainel;

    if (this.pCentroDistribuicao) {
      idFornecedorPainel = this.cliente.idCD;
    }

    if (this.multiFornecedores) {
      idFornecedorPainel = this.orcamento.painelProduto.idFornecedor;
    }

    this.produtoService.buscarEstoque(itens.map(p => p.produto), idFornecedorPainel === null || idFornecedorPainel === undefined ? null : idFornecedorPainel, null).subscribe(estoque => {
      itens.forEach(p => {
        const estoqueDoProduto = estoque.find(e => e.idProduto === p.produto);

        if (estoqueDoProduto) {
          p.produtoTela.qtEstoque = estoqueDoProduto.qtEstoque;
          p.produtoTela.qtReserva = estoqueDoProduto.qtReserva;
        } else {
          p.produtoTela.qtEstoque = 0;
          p.produtoTela.qtReserva = 0;
        }
      });

      this.carregandoService.esconde('buscarEstoque');
    }, (erro) => {
      this.carregandoService.esconde('buscarEstoque');
      this.notificacaoService.erro(erro);
    });
  }

  exibirEstoque(item) {

    if (item === null || item === undefined || item.produtoTela === null || item.produtoTela === undefined
      || item.produtoTela.qtEstoque === null || item.produtoTela.qtEstoque === undefined
      || item.produtoTela.qtReserva === null || item.produtoTela.qtReserva === undefined) return false;

    return true;
  }

  calcularValorTotalItensSemDesconto() {
    return this.itens.reduce((acc, curr) => (acc + curr.vTotal), 0);
  }

}
